import React from "react";
import history from './history';
import {
	PRODUCT_IMG_URL, DEFAULT_PRODUCT_IMAGE, DEFAULT_SUBCATEGORY_IMAGE, DEFAULT_CATEGORY_IMAGE, ORDER_EXPIRE_TIME_HOURS, PRODUCT_THUMB_IMG_URL, DEFAULT_PRODUCT_THUMB_IMAGE,
	SETTINGS_IMG_URL, IMAGE_CAT_IMAGES_PATH, PLACE_IMG_URL, TABL_USER_ADDRESSES_KEY, VIDEOS_URL, CATEGORY_PDF_URL
} from '../constants';

import { sortBy, isEqual } from 'lodash'
import { PolyUtil } from "node-geometry-library";
import getDistance from 'geolib/es/getDistance';
import store from './../store';

import { setScrollData } from './../menu/menu.actions';
import Auth from "./Auth";
import { cartStorage } from "./fromLinkMode";
import { isBoughtDomain } from "./boughtDomain";

class Utils {

	// Encode image filename for safe use in CSS url() - handles parentheses and special characters
	static encodeImagePath = (path) => {
		if (!path) return path;
		// Encode special characters that break CSS url() - parentheses, spaces, quotes, etc.
		return path.replace(/[()'" ]/g, char => encodeURIComponent(char));
	}

	// Branding of the "About TabL" page/menu item, resolved from the current domain.
	// - tablmenu.com is the international brand -> show tablmenu.com / info@tablmenu.com
	// - bohemi-pamporovo.bg / .com bought the software, so the TabL section is hidden completely
	static getBrand() {
		const host = (window.location.hostname || '').toLowerCase().replace(/^www\./, '');

		const isHost = (domain) => host === domain || host.endsWith('.' + domain);

		if (isBoughtDomain()) {
			return { site: null, email: null, hideAboutTabl: true };
		}

		if (isHost('tablmenu.com')) {
			return { site: 'tablmenu.com', email: 'info@tablmenu.com', hideAboutTabl: false };
		}

		return { site: null, email: 'info@tabl.bg', hideAboutTabl: false };
	}

	static cropMail(email) {
		if (email && (email.indexOf("@") !== -1)) {
			return email.split("@")[0];
		}
		return email;
	}

	static objectToFormData(obj) {
		let formData = new FormData();
		for (var key in obj) {
			formData.append(key, obj[key]);
		}
		return formData;
	}

	static onChange(e) {
		return { [e.target.name]: (e.target.type && e.target.type === 'number') ? parseFloat(e.target.value) : e.target.value }
	}

	static onChangeCheckbox(e) {
		return { [e.target.name]: e.target.checked ? 1 : 0 };
	}

	static truncate(input, maxInputLength = 15, cutFirstXSymbold = 5) {
		if (input && input.length > maxInputLength)
			return input.substring(0, cutFirstXSymbold) + '...';
		else
			return input;
	}

	static appendLeadingZeroes = (n) =>
		(n <= 9 ? "0" + n : n)

	static buildURLQuery = (obj) =>
		Object.entries(obj)
			.map(pair => pair.map(encodeURIComponent).join('='))
			.join('&');

	static changeListDateFormat = (d) => {
		let bgMonths = [];
		bgMonths[0] = 'яну';
		bgMonths[1] = 'фев';
		bgMonths[2] = 'март';
		bgMonths[3] = 'апр';
		bgMonths[4] = 'май';
		bgMonths[5] = 'юни';
		bgMonths[6] = 'юли';
		bgMonths[7] = 'авг';
		bgMonths[8] = 'сеп';
		bgMonths[9] = 'окт';
		bgMonths[10] = 'ное';
		bgMonths[11] = 'дек';

		return this.appendLeadingZeroes(d.getDate()) + '-' + bgMonths[d.getMonth()] + '-' + d.getFullYear() + ' ' + this.appendLeadingZeroes(d.getHours()) + ':' + this.appendLeadingZeroes(d.getMinutes())
	}

	static errorHandler(error) {
		const customErrorMsg = "Възникна грешка #";
		let errorCode = 0;

		// https://gist.github.com/fgilio/230ccd514e9381fafa51608fcf137253
		if (error.response) {
			errorCode = 1;
			console.log(error.response.data); //DO NOT REMOVE
			console.log(error.response.status); //DO NOT REMOVE
			console.log(error.response.headers); //DO NOT REMOVE
			/*
				* The request was made and the server responded with a
				* status code that falls out of the range of 2xx
			*/
		} else if (error.request) {
			errorCode = 2;
			errorCode += ' - Проблем със сървъра или слаб интернет!';
			/*
			* The request was made but no response was received, `error.request`
			* is an instance of XMLHttpRequest in the browser and an instance
			* of http.ClientRequest in Node.js
			*/
			console.log(error.request); //DO NOT REMOVE
		} else {
			errorCode = 3;
			// Something happened in setting up the request and triggered an Error
			console.log('Error', error.message); //DO NOT REMOVE
		}

		return customErrorMsg + errorCode;
	}

	static navigateTo = (url) => {
		history.push(url);
	}


	static getSettingsPath = (imgSrc) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			}
			if (window.location.hostname == 'localhost') {
				return SETTINGS_IMG_URL.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc);
			}
			return SETTINGS_IMG_URL + Utils.encodeImagePath(imgSrc);
		}
		return '';
	}

	// Настройка `images_cache_version`: ако има стойност, добавяме ?v=<стойност> към снимките на продуктите и категориите,
	// за да вземе Cloudflare/браузърът новия файл след прекачване със същото име (напр. прозрачни миниатюри).
	static withImagesCacheVersion = (url) => {
		const version = Utils.getSetting('images_cache_version');
		if (!url || !version) {
			return url;
		}
		return url + (url.indexOf('?') === -1 ? '?' : '&') + 'v=' + encodeURIComponent(String(version).trim());
	}

	static getProductImagePath = (imgSrc, returnDefaultImage = 0) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			}
			if (window.location.hostname == 'localhost') {
				return Utils.withImagesCacheVersion(PRODUCT_IMG_URL.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc));
			}
			return Utils.withImagesCacheVersion(PRODUCT_IMG_URL + Utils.encodeImagePath(imgSrc));
		}
		if (returnDefaultImage) {
			return DEFAULT_PRODUCT_IMAGE;
		}
		return '';
	}

	static getProductThumbImagePath = (imgSrc, returnDefaultImage = 0) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			}
			if (window.location.hostname == 'localhost') {
				return Utils.withImagesCacheVersion(PRODUCT_THUMB_IMG_URL.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc));
			}
			return Utils.withImagesCacheVersion(PRODUCT_THUMB_IMG_URL + Utils.encodeImagePath(imgSrc));
		}
		if (returnDefaultImage) {
			return DEFAULT_PRODUCT_THUMB_IMAGE;
		}
		return '';
	}

	static getSubcategoryImagePath = (imgSrc, returnDefaultImage = 0) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			}
			if (window.location.hostname == 'localhost') {
				return Utils.withImagesCacheVersion(PRODUCT_THUMB_IMG_URL.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc));
			}
			return Utils.withImagesCacheVersion(PRODUCT_THUMB_IMG_URL + Utils.encodeImagePath(imgSrc));
		}
		if (returnDefaultImage) {
			return DEFAULT_SUBCATEGORY_IMAGE;
		}
		return '';
	}


	static getCategoryImagePath = (imgSrc) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			} else {
				if (window.location.hostname == 'localhost') {
					return Utils.withImagesCacheVersion(PRODUCT_THUMB_IMG_URL.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc)); //TODO this is not product_img_url
				}
				return Utils.withImagesCacheVersion(PRODUCT_THUMB_IMG_URL + Utils.encodeImagePath(imgSrc)); //TODO this is not product_img_url
			}
		}
		return DEFAULT_CATEGORY_IMAGE;
	}

	// Визия на кутийката на категорията (таб „Визия" в админа) - max-width на самата кутийка.
	static getCategoryBoxStyle = (category) => {
		let style = {};
		if (!category) {
			return style;
		}
		// Категория само за надпис/разделител - да не изглежда като бутон, за да не я чака клиентът да се отвори.
		if (category.not_clickable == 1) {
			style.cursor = 'default';
		}
		if (!category.box_max_width) {
			return style;
		}
		let maxWidth = String(category.box_max_width).trim().replace(',', '.');
		if (/^\d+(\.\d+)?$/.test(maxWidth)) {
			maxWidth += 'px';
		}
		if (/^\d+(\.\d+)?(px|%|rem|em|vw)$/i.test(maxWidth)) {
			style.maxWidth = maxWidth;
		}
		return style;
	}

	// Частта със снимката в кутийката (елементът с background-image): цвят на фона само там, а при box_image_contain
	// снимката се вижда цялата, без изрязване и без повторение.
	static getCategoryBoxImageStyle = (category) => {
		let style = {};
		if (!category) {
			return style;
		}
		if (category.box_image_contain == 1) {
			style.backgroundSize = 'contain';
			style.backgroundRepeat = 'no-repeat';
			style.backgroundPosition = 'center';
		}
		if (category.box_background_color) {
			style.backgroundColor = String(category.box_background_color).trim();
		}
		return style;
	}

	// Обща фонова снимка (настройка `product_image_background`) зад снимките на продуктите и категориите -
	// за снимки без фон (прозрачен PNG). Празна настройка = както досега.
	static getProductImageBackgroundPath = () => {
		return Utils.getSettingsPath(Utils.getSetting('product_image_background')) || '';
	}

	// Добавя фоновата снимка като ВТОРИ слой под снимката. Размерът/позицията на снимката остават каквито са,
	// а фонът винаги е cover (запълва цялата кутийка). imageSize/imagePosition/imageRepeat са тези на снимката.
	static getImageWithBackgroundStyle = (imageUrl, imageSize = 'cover', imagePosition = 'center', imageRepeat = 'no-repeat') => {
		const bgPath = Utils.getProductImageBackgroundPath();
		if (!bgPath || !imageUrl) {
			return {};
		}
		return {
			backgroundImage: `url("${imageUrl}"), url("${bgPath}")`,
			backgroundSize: `${imageSize}, cover`,
			backgroundPosition: `${imagePosition}, center`,
			backgroundRepeat: `${imageRepeat}, no-repeat`,
		};
	}

	// Същото за кутийката на категорията. Ако категорията има собствен цвят зад снимката (таб „Визия"), той печели.
	static getCategoryImageWithBackgroundStyle = (category) => {
		if (!category || !category.icon || category.box_background_color) {
			return {};
		}
		return Utils.getImageWithBackgroundStyle(Utils.getSubcategoryImagePath(category.icon, 1), category.box_image_contain == 1 ? 'contain' : 'cover');
	}

	// За <img> елементи: фонът се вижда през прозрачните части на снимката.
	static getImgTagBackgroundStyle = () => {
		const bgPath = Utils.getProductImageBackgroundPath();
		if (!bgPath) {
			return {};
		}
		return {
			backgroundImage: `url("${bgPath}")`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
		};
	}


	static getImageCategoryImagePath = (imgSrc) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			} else {
				if (window.location.hostname == 'localhost') {
					return IMAGE_CAT_IMAGES_PATH.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc); //TODO this is not product_img_url
				}
				return IMAGE_CAT_IMAGES_PATH + Utils.encodeImagePath(imgSrc); //TODO this is not product_img_url
			}
		}
		return DEFAULT_CATEGORY_IMAGE;
	}

	static getPlaceImagePath = (imgSrc, returnDefaultImage = 0) => {
		if (imgSrc) {
			if ((imgSrc.indexOf('http://') === 0 || imgSrc.indexOf('https://') === 0)) {
				return Utils.encodeImagePath(imgSrc);
			}
			if (window.location.hostname == 'localhost') {
				return PLACE_IMG_URL.replace(window.location.origin, 'https://menu.tabl.bg') + Utils.encodeImagePath(imgSrc);
			}
			return PLACE_IMG_URL + Utils.encodeImagePath(imgSrc);
		}
		if (returnDefaultImage) {
			return "https://tabl.bg/img/default-place-image.jpg";
		}

		return '';
	}

	static getCategoryVideoPath = (videoName) => {
		if (videoName) {
			if ((videoName.indexOf('http://') === 0 || videoName.indexOf('https://') === 0)) {
				return videoName;
			}
			if (window.location.hostname == 'localhost') {
				return VIDEOS_URL.replace(window.location.origin, 'https://menu.tabl.bg') + videoName;
			}

			return VIDEOS_URL + "/" + videoName
		}
		return '';
	}

	static getCategoryPdfPath = (pdfName) => {
		if (pdfName) {
			if ((pdfName.indexOf('http://') === 0 || pdfName.indexOf('https://') === 0)) {
				return pdfName;
			}
			if (window.location.hostname == 'localhost') {
				return CATEGORY_PDF_URL.replace(window.location.origin, 'https://menu.tabl.bg') + pdfName;
			}

			return CATEGORY_PDF_URL + pdfName
		}
		return '';
	}

	// Returns the top-level (hierarchyLevel 1) menu categories using the SAME
	// order-type / browse / qr filters the standard menu applies, so the PDF and
	// elegant visions show exactly the same categories as the standard vision.
	static filterTopLevelMenuCategories = (catsHierarchy) => {
		const tokenOrderType = Auth.getTokenOrderType();
		let cats = Object.values(catsHierarchy || [])
			.filter(c => c.hierarchyLevel == 1)
			.filter(c => (c.show_cat_only_for_spot_orders == 1 ? tokenOrderType == 1 : true))
			.filter(c => (c.show_cat_only_for_delivery_orders == 1 ? tokenOrderType == 2 : true))
			.filter(c => (tokenOrderType == 1 ? c.hide_cat_only_for_spot_orders == 0 : true))
			.filter(c => (tokenOrderType == 2 ? c.hide_cat_only_for_delivery_orders == 0 : true))
			.filter(c => (c.show_only_if_scanned_qr == 1 ? !!Auth.getUserToken() : true))
			.filter(c => (c.show_only_for_spot_browse == 0 ? true : (c.show_only_for_spot_browse == 1 && tokenOrderType == 4 ? true : false)))
			.filter(c => (c.hide_only_for_spot_browse == 0 ? true : (c.hide_only_for_spot_browse == 1 && tokenOrderType == 4 ? false : true)))
			.filter(c => (c.show_cat_only_for_delivery_orders == 0 ? true : (c.show_cat_only_for_delivery_orders == 1 && tokenOrderType == 2 ? true : false)))
			.filter(c => (c.hide_cat_only_for_delivery_orders == 0 ? true : (c.hide_cat_only_for_delivery_orders == 1 && tokenOrderType == 2 ? false : true)))
			.filter(c => (c.show_cat_only_for_room_orders == 0 ? true : (c.show_cat_only_for_room_orders == 1 && tokenOrderType == 6 ? true : false)))
			.filter(c => (c.hide_cat_only_for_room_orders == 0 ? true : (c.hide_cat_only_for_room_orders == 1 && tokenOrderType == 6 ? false : true)))
			.sort(this.sortPriority());
		return cats;
	}

	static checkProductAllowedOrdering = (productCats, allCats) => {
		let productOrderAllowed = false;

		if (productCats && allCats && Object.keys(allCats).length > 0) {
			Object.values(allCats).map(c => {
				if (productCats.includes(c.id)) {
					productOrderAllowed = productOrderAllowed || c.order_allowed
				}
			});
		}

		return productOrderAllowed;
	}


	static normalizePrice = (price) => {
		return price.toFixed(2);
	}



	static calculateAnimationTimeout = (k) => {
		const animTimeout = 450 + (k * 100);
		return (animTimeout > 3000) ? 3000 : animTimeout;
	}



	static fireEvent = (element, event) => {
		// console.log("in Fire Event");
		if (document.createEventObject) {
			// dispatch for IE
			// console.log("in IE FireEvent");
			var evt = document.createEventObject();
			return element.fireEvent('on' + event, evt)
		}
		else {
			// dispatch for firefox + others
			// console.log("In HTML5 dispatchEvent");
			var evt = document.createEvent("HTMLEvents");
			evt.initEvent(event, true, true); // event type,bubbling,cancelable
			return !element.dispatchEvent(evt);
		}
	}

	// Returns the active Google Translate target language (e.g. 'en') when the page
	// is currently being translated by the Google Translate widget, otherwise null.
	// The widget stores its state in the `googtrans` cookie as `/<source>/<target>`.
	// We treat a target equal to the source (or missing) as "not translating".
	static getActiveGoogleTranslateLang = () => {
		try {
			let match = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
			if (!match) return null;
			let parts = decodeURIComponent(match[1]).split('/'); // ["", "bg", "en"]
			let source = parts[1];
			let target = parts[2];
			if (target && target !== source) return target;
			return null;
		} catch (e) {
			return null;
		}
	}

	static getSettingsValue = (settings, settingsName = '', returnDefault = false) => {
		if (settingsName && settings && Object.values(settings).length > 0 && settings[settingsName] && settings[settingsName].value && (settings[settingsName].value).toString().length > 0) {
			return settings[settingsName].value;
		}
		return returnDefault;
	}

	// Задължителни полета от адреса при доставка (required_address_fields), напр. { streetNumber: 1, buildingNumber: 1, apNumber: 1 }.
	// null = нищо не е избрано -> старото поведение (№ или бл. + make_required_all_address_fields).
	static ADDRESS_FIELDS = ['streetNumber', 'buildingNumber', 'floorNumber', 'apNumber', 'bellNumber', 'entranceNumber'];

	static getRequiredAddressFields = (settings) => {
		let value = this.getSettingsValue(settings, 'required_address_fields');
		if (typeof value == 'string') {
			try {
				value = JSON.parse(value);
			} catch (e) {
				value = null;
			}
		}
		if (!value || typeof value != 'object') {
			return null;
		}
		const required = {};
		this.ADDRESS_FIELDS.forEach(field => {
			if (value[field] == 1) {
				required[field] = true;
			}
		});
		return Object.keys(required).length > 0 ? required : null;
	}

	// Датите за поръчка са „MM.DD“ без година. Ако с текущата година датата излиза
	// повече от месец назад, значи е след Нова година (напр. на 28.12 избрано 02.01).
	static getOrderDateYear = (month, day) => {
		const now = new Date();
		const dateThisYear = new Date(now.getFullYear(), parseInt(month) - 1, parseInt(day));
		const monthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
		return dateThisYear < monthAgo ? now.getFullYear() + 1 : now.getFullYear();
	}

	// Check if product should be shown based on price (hide products with all variants having price 0)
	static shouldShowProduct = (product, settings) => {
		if (this.getSettingsValue(settings, 'hide_articles_with_price_zero') == '1') {
			const hasNonZeroPrice = product.product_variants && product.product_variants.some(v => parseFloat(v.price) > 0);
			if (!hasNonZeroPrice) {
				return false;
			}
		}
		return true;
	}

	static replaceString = (inputString, stringToBeReplaced, stringForReplace, replaceWithNewLine) => {
		if (replaceWithNewLine) {
			return inputString.split(stringToBeReplaced).flatMap((part, index) =>
				index > 0 ? [<br key={index} />, part] : [part]
			);
		} else {
			return inputString.split(stringToBeReplaced).join(stringForReplace);
		}
	}

	static getSetting = (name) => {
		let currState = store.getState();
		if (currState && currState.settings && currState.settings.settings && currState.settings.settings[name] && currState.settings.settings[name].value) {
			return currState.settings.settings[name].value;
		}

		return null;
	}

	// Geo-fence for spot/room orders (security feature). When `restrict_spot_room_by_location`
	// is on, the customer must allow GPS and be inside the admin-drawn `order_location_fence`.
	static isOrderLocationRestricted = () => {
		return Utils.getSetting('restrict_spot_room_by_location') == '1';
	}

	// Parse the newline-separated "lat, lng" fence text into an array of { lat, lng } points.
	static getOrderLocationFencePolygon = () => {
		let raw = Utils.getSetting('order_location_fence');
		if (!raw || typeof raw != 'string') return [];

		let points = [];
		raw.split(/\r?\n/).forEach(line => {
			let parts = line.split(',');
			if (parts.length == 2) {
				let lat = parseFloat(parts[0]);
				let lng = parseFloat(parts[1]);
				if (!isNaN(lat) && !isNaN(lng)) {
					points.push({ lat, lng });
				}
			}
		});

		return points;
	}

	// Requests the device location and checks it against the allowed-ordering polygon.
	// Never rejects - always resolves with a structured result so the caller (the location
	// modal) can render the right message and decide whether to auto-submit:
	//   { status: 'inside', lat, lng }   -> inside the zone, submit the order
	//   { status: 'not_restricted' }     -> restriction on but no polygon drawn yet (don't block)
	//   { status: 'outside', lat, lng }  -> located but outside the allowed zone
	//   { status: 'denied', code }       -> permission denied / unavailable / timeout
	//   { status: 'unsupported' }        -> browser has no geolocation API
	static checkOrderLocation = () => {
		return new Promise((resolve) => {
			const polygon = Utils.getOrderLocationFencePolygon();

			if (polygon.length < 3) {
				return resolve({ status: 'not_restricted' });
			}

			if (!navigator.geolocation) {
				return resolve({ status: 'unsupported' });
			}

			navigator.geolocation.getCurrentPosition(
				(position) => {
					const lat = position.coords.latitude;
					const lng = position.coords.longitude;
					if (PolyUtil.containsLocation({ lat, lng }, polygon)) {
						resolve({ status: 'inside', lat, lng });
					} else {
						resolve({ status: 'outside', lat, lng });
					}
				},
				(error) => {
					resolve({ status: 'denied', code: error && error.code });
				},
				{ enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
			);
		});
	}

	// {this.translate(this.props.translations.common.dashboard, {count: 5, total: 8})}
	static translate(text, args = {}) {
		if (Object.keys(args).length === 0) {
			return text;
		}

		Object.entries(args).map(a => text = text.replace('{' + a[0] + '}', a[1]))
		return text;
	}

	static validatedCommentObject(allComments, variantId, comment, cartItemUuid = null) {
		// When a cart line uuid is given, the comment is per-cart-line (matched by cart_item_uuid).
		// Otherwise it is per-variant (legacy, e.g. from the product page). variantId is kept on the
		// object in both cases for backward-compatible readers (warehouse integrations, admin).
		const commentExists = cartItemUuid
			? allComments.findIndex(p => p.cart_item_uuid && p.cart_item_uuid === cartItemUuid)
			: allComments.findIndex(p => parseInt(p.variantId) == parseInt(variantId));
		if (commentExists === -1) {
			if (!comment) {
				return false;
			}

			let currentComment = {}
			currentComment.variantId = variantId;
			currentComment.comment = comment;
			if (cartItemUuid) {
				currentComment.cart_item_uuid = cartItemUuid;
			}

			allComments.push(currentComment);
		} else {
			allComments[commentExists].comment = comment;
		}

		return allComments;
	}


	// Categories and Subcategories
	static splitCatSubcatOnTwoRowsBySpace(name, settings) {
		if ((settings && settings.split_header_category_subcategory_on_two_rows && settings.split_header_category_subcategory_on_two_rows.value && settings.split_header_category_subcategory_on_two_rows.value == '1')
			&& (name.indexOf(' ') !== -1)) {
			// Used if two spaces in string // bugfix
			let secondPartsString = '';
			let secondPartArr = (name.split(' ')).slice(1);
			secondPartArr.map(a => secondPartsString += (' ' + a))

			return <React.Fragment>{name.split(' ')[0]}<br />{secondPartsString}</React.Fragment>
		} else if (settings && settings.replace_slash_with_new_line_category_list && settings.replace_slash_with_new_line_category_list.value && settings.replace_slash_with_new_line_category_list.value == '1') {
			return this.replaceString(name, '/', '', 1);
		} else {
			return name;
		}
	}

	// Orders
	// Async function to check working status via new API
	// Returns { isOpen, reason, nextOpenInfo, timeSlots }
	static async getWorkingStatus(placeId, dateTime = null) {
		try {
			const { API_URL } = require('../constants');
			let url = `${API_URL}working-hours/status?placeId=${placeId}`;
			if (dateTime) {
				url += `&dateTime=${dateTime.toISOString()}`;
			}

			const response = await fetch(url);
			if (!response.ok) {
				throw new Error('Failed to fetch working status');
			}
			return await response.json();
		} catch (error) {
			console.error('Error fetching working status:', error);
			return null; // Fallback to old method if API fails
		}
	}

	// Async function to get available time slots for a date
	static async getAvailableTimeSlots(placeId, date, ordertypeId = null, interval = 15) {
		try {
			const { API_URL } = require('../constants');
			const dateStr = typeof date === 'string' ? date : date.toISOString().split('T')[0];
			let url = `${API_URL}working-hours/available-slots?placeId=${placeId}&date=${dateStr}&interval=${interval}`;
			if (ordertypeId) {
				url += `&ordertypeId=${ordertypeId}`;
			}

			const response = await fetch(url);
			if (!response.ok) {
				throw new Error('Failed to fetch available slots');
			}
			return await response.json();
		} catch (error) {
			console.error('Error fetching available slots:', error);
			return null; // Fallback to old method if API fails
		}
	}

	// Helper to format next open info as a user-friendly message
	static formatNextOpenMessage(nextOpenInfo, translations) {
		if (!nextOpenInfo) {
			return translations?.pages?.cart_delivery?.restaurant_closed_label || 'Затворено';
		}

		const { dayOffset, time, isToday } = nextOpenInfo;
		const t = translations?.pages?.cart_delivery;

		if (isToday && dayOffset === 0) {
			// Opens later today
			return t?.restaurant_opens_today?.replace('{time}', time) || `Отваряме днес в ${time}`;
		} else if (dayOffset === 1) {
			// Opens tomorrow
			return t?.restaurant_closed_label_tommorow?.replace('{value}', time) || `Отваряме утре в ${time}`;
		} else {
			// Opens in X days
			const date = new Date();
			date.setDate(date.getDate() + dayOffset);
			const dayName = date.toLocaleDateString('bg-BG', { weekday: 'long' });
			return t?.restaurant_closed_label_day?.replace('{day}', dayName).replace('{value}', time) ||
				`Отваряме в ${dayName} в ${time}`;
		}
	}

	// Checks if ordering is enabled, based on settings
	static disabledOrdering(settings, date = new Date()) {

		// Not disabled overtime orders
		if (settings.disable_overtime_orders && settings.disable_overtime_orders.value && settings.disable_overtime_orders.value != 1) {
			return false;
		}

		// Check exceptions first (highest priority - overrides weekly schedule)
		const exceptionsV2 = settings.working_hours_exceptions_v2 && settings.working_hours_exceptions_v2.value;
		if (exceptionsV2) {
			// Format date as YYYY-MM-DD
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const dateStr = `${year}-${month}-${day}`;

			const exception = exceptionsV2[dateStr];
			if (exception) {
				// Exception found for this date
				if (exception.is_closed == 1) {
					return true; // Closed for this specific date
				}

				// Check exception time slots
				const timeSlots = exception.time_slots;
				if (!timeSlots || timeSlots.length === 0) {
					return true; // No time slots in exception means closed
				}

				const nowHour = date.getHours();
				const nowMinutes = date.getMinutes();
				const nowTotalMinutes = nowHour * 60 + nowMinutes;

				let withinAnySlot = false;
				for (let slot of timeSlots) {
					if (slot.from && slot.to) {
						const fromParts = slot.from.split(':');
						const toParts = slot.to.split(':');
						const fromTotalMinutes = parseInt(fromParts[0]) * 60 + parseInt(fromParts[1]);
						const toTotalMinutes = parseInt(toParts[0]) * 60 + parseInt(toParts[1]);

						if (nowTotalMinutes >= fromTotalMinutes && nowTotalMinutes <= toTotalMinutes) {
							withinAnySlot = true;
							break;
						}
					}
				}

				return !withinAnySlot;
			}
		}

		let nowDayInt = date.getDay();
		if (nowDayInt == 0) {
			nowDayInt = 7;
		}

		// Check new working hours schedule v2
		const scheduleV2 = settings.working_hours_schedule_v2 && settings.working_hours_schedule_v2.value;
		if (scheduleV2 && scheduleV2[nowDayInt]) {
			const daySchedule = scheduleV2[nowDayInt];

			// Check if day is closed
			if (daySchedule.is_closed == 1) {
				return true;
			}

			// Check time slots
			const timeSlots = daySchedule.time_slots;
			if (!timeSlots || timeSlots.length === 0) {
				return true; // No time slots means closed
			}

			const nowHour = date.getHours();
			const nowMinutes = date.getMinutes();
			const nowTotalMinutes = nowHour * 60 + nowMinutes;

			// Check if current time is within any time slot
			let withinAnySlot = false;
			for (let slot of timeSlots) {
				if (slot.from && slot.to) {
					const fromParts = slot.from.split(':');
					const toParts = slot.to.split(':');
					const fromTotalMinutes = parseInt(fromParts[0]) * 60 + parseInt(fromParts[1]);
					const toTotalMinutes = parseInt(toParts[0]) * 60 + parseInt(toParts[1]);

					if (nowTotalMinutes >= fromTotalMinutes && nowTotalMinutes <= toTotalMinutes) {
						withinAnySlot = true;
						break;
					}
				}
			}

			return !withinAnySlot;
		}

		// Fallback to old working_hours setting
		let working_hours = this.getSettingsValue(settings, 'working_hours');
		if (!working_hours || !working_hours[nowDayInt]) {
			return true;
		}

		let working_hours_day = working_hours[nowDayInt];

		// If disabled the whole day
		if (!working_hours_day || working_hours_day == '-') {
			return true;
		} else {
			const nowHour = date.getHours();
			const nowMinutes = date.getMinutes();

			let working_hours_splited = working_hours_day.split('-');

			let minPickupTime = working_hours_splited[0];
			let minPickupTimeHours = parseInt(minPickupTime.split(':')[0]);
			let minPickupTimeMinutes = parseInt(minPickupTime.split(':')[1]);

			let maxPickupTime = working_hours_splited[1];
			let maxPickupTimeHours = parseInt(maxPickupTime.split(':')[0]);
			let maxPickupTimeMinutes = parseInt(maxPickupTime.split(':')[1]);

			if (nowHour > maxPickupTimeHours || nowHour < minPickupTimeHours) {
				return true;
			} else {
				if (nowHour == minPickupTimeHours && nowMinutes < minPickupTimeMinutes) {
					return true;
				} else if (nowHour == maxPickupTimeHours && nowMinutes > maxPickupTimeMinutes) {
					return true;
				}
			}

			return false;

		}

	}


	// Check if a specific order type is available based on its schedule settings
	static isOrderTypeAvailable(orderType, settings) {
		if (!orderType) return false;

		// Junction table data may be nested in place_ordertype
		const po = orderType.place_ordertype || orderType;

		const scheduleType = po.schedule_type || 'inherit';

		// If disabled, order type is not available
		if (scheduleType === 'disabled') {
			return false;
		}

		const now = new Date();
		const dayOfWeek = now.getDay(); // 0=Sunday, 1-6=Mon-Sat
		const dayId = dayOfWeek === 0 ? 7 : dayOfWeek; // Convert to 1=Mon,...,7=Sun
		const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
		const isWeekday = !isWeekend;

		// Per-day check (takes priority over weekday/weekend)
		let daysEnabled = po.days_enabled;
		if (daysEnabled && typeof daysEnabled === 'string') {
			try { daysEnabled = JSON.parse(daysEnabled); } catch(e) { daysEnabled = null; }
		}
		if (daysEnabled && Array.isArray(daysEnabled)) {
			if (daysEnabled.indexOf(dayId) === -1) {
				return false;
			}
		}

		// Check if today is a public holiday
		const publicHolidays = settings.public_holidays && settings.public_holidays.value;
		if (publicHolidays) {
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0');
			const day = String(now.getDate()).padStart(2, '0');
			const todayStr = `${year}-${month}-${day}`;

			if (publicHolidays[todayStr]) {
				// Today is a public holiday
				if (po.holiday_enabled === 0) {
					return false; // This order type is disabled on holidays
				}
				// If holiday_enabled is 1 or not set, continue with other checks
			}
		}

		// Check weekday/weekend enabled flags
		if (isWeekday && po.weekday_enabled === 0) {
			return false;
		}
		if (isWeekend && po.weekend_enabled === 0) {
			return false;
		}

		// If schedule_type is 'inherit', use place working hours (already handled by disabledOrdering)
		if (scheduleType === 'inherit') {
			return true; // Let disabledOrdering handle it
		}

		// If schedule_type is 'custom', check the order type's own time slots
		if (scheduleType === 'custom') {
			// Determine which time slots to use
			let timeSlots = po.time_slots;
			if (isWeekday && po.weekday_time_slots && po.weekday_time_slots.length > 0) {
				timeSlots = po.weekday_time_slots;
			} else if (isWeekend && po.weekend_time_slots && po.weekend_time_slots.length > 0) {
				timeSlots = po.weekend_time_slots;
			}

			if (!timeSlots || timeSlots.length === 0) {
				return false; // No time slots defined
			}

			// Check if current time is within any slot
			const nowHour = now.getHours();
			const nowMinutes = now.getMinutes();
			const nowTotalMinutes = nowHour * 60 + nowMinutes;

			for (let slot of timeSlots) {
				if (slot.from && slot.to) {
					const fromParts = slot.from.split(':');
					const toParts = slot.to.split(':');
					const fromTotalMinutes = parseInt(fromParts[0]) * 60 + parseInt(fromParts[1]);
					const toTotalMinutes = parseInt(toParts[0]) * 60 + parseInt(toParts[1]);

					if (nowTotalMinutes >= fromTotalMinutes && nowTotalMinutes <= toTotalMinutes) {
						return true; // Within this time slot
					}
				}
			}

			return false; // Not within any time slot
		}

		return true;
	}


	// Helper to build message with next working day info
	static getNextWorkingDayMessage(translations, settings, exceptionsV2, currentDayInt, now, addDays, isExceptionClosed = false) {
		const scheduleV2 = settings.working_hours_schedule_v2 && settings.working_hours_schedule_v2.value;
		const closedText = translations?.pages?.cart_delivery?.closed_today_exception || 'В момента не приемаме поръчки, моля опитайте отново';
		const tomorrowText = translations?.pages?.cart_delivery?.tomorrow || 'утре в';
		const onDayText = translations?.pages?.cart_delivery?.on_day || 'в';

		if (!scheduleV2) {
			return closedText;
		}

		// Find next working day starting from tomorrow
		for (let i = 1; i <= 7; i++) {
			let checkDayInt = currentDayInt + i;
			if (checkDayInt > 7) checkDayInt -= 7;

			const daySchedule = scheduleV2[checkDayInt];
			if (!daySchedule || daySchedule.is_closed == 1 || !daySchedule.time_slots || daySchedule.time_slots.length === 0) {
				continue; // This day is closed in weekly schedule
			}

			// Check if this future date has a closed exception
			if (exceptionsV2) {
				const futureDate = addDays(now, i);
				const futureDateStr = `${futureDate.getFullYear()}-${String(futureDate.getMonth() + 1).padStart(2, '0')}-${String(futureDate.getDate()).padStart(2, '0')}`;
				const futureException = exceptionsV2[futureDateStr];

				if (futureException) {
					if (futureException.is_closed == 1) {
						continue; // This day has a closed exception
					}
					// If exception has custom time slots, use those
					if (futureException.time_slots && futureException.time_slots.length > 0) {
						const slotsStr = futureException.time_slots.map(s => s.from + '-' + s.to).join(', ');
						if (i === 1) {
							return `${closedText} ${tomorrowText} ${slotsStr}`;
						} else {
							const nextDayName = translations?.common?.date?.day?.[checkDayInt] || '';
							return `${closedText} ${onDayText} ${nextDayName} ${slotsStr}`;
						}
					}
				}
			}

			// Use weekly schedule time slots
			const slotsStr = daySchedule.time_slots.map(s => s.from + '-' + s.to).join(', ');

			if (i === 1) {
				// Tomorrow - "В момента не приемаме поръчки, моля опитайте отново утре в 09:30-22:00"
				return `${closedText} ${tomorrowText} ${slotsStr}`;
			} else {
				// Other day - "В момента не приемаме поръчки, моля опитайте отново в Понеделник 09:30-22:00"
				const nextDayName = translations?.common?.date?.day?.[checkDayInt] || '';
				return `${closedText} ${onDayText} ${nextDayName} ${slotsStr}`;
			}
		}

		// No working day found in the next 7 days
		return closedText;
	}

	// Always prints message, check first if ordering is enabled by calling: this.disabledOrdering
	// If this method is called => orders are disabled for the current time
	static getDisabledOrderingMessage(translations, settings) {
		const currentHour = new Date().getHours();
		const currentMinutes = new Date().getMinutes();
		const currentTotalMinutes = currentHour * 60 + currentMinutes;

		let currentDayInt = new Date().getDay();
		if (currentDayInt == 0) {
			currentDayInt = 7;
		}

		function addDays(date, days) {
			var result = new Date(date);
			result.setDate(result.getDate() + days);
			return result;
		}

		// Helper to convert time slots to display string
		function timeSlotsToString(timeSlots) {
			if (!timeSlots || timeSlots.length === 0) return '-';
			return timeSlots.map(slot => slot.from + '-' + slot.to).join(', ');
		}

		// Helper to get first opening time from slots
		function getFirstOpeningTime(timeSlots) {
			if (!timeSlots || timeSlots.length === 0) return null;
			return timeSlots[0].from;
		}

		// Check exceptions first (highest priority)
		const exceptionsV2 = settings.working_hours_exceptions_v2 && settings.working_hours_exceptions_v2.value;
		if (exceptionsV2) {
			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0');
			const day = String(now.getDate()).padStart(2, '0');
			const dateStr = `${year}-${month}-${day}`;

			const exception = exceptionsV2[dateStr];
			if (exception) {
				// Today has an exception
				if (exception.is_closed == 1) {
					// Closed today due to exception - find next working day
					return this.getNextWorkingDayMessage(translations, settings, exceptionsV2, currentDayInt, now, addDays, true);
				}

				// Exception with time slots - find next available slot
				const timeSlots = exception.time_slots;
				if (timeSlots && timeSlots.length > 0) {
					for (let slot of timeSlots) {
						if (slot.from && slot.to) {
							const fromParts = slot.from.split(':');
							const fromTotalMinutes = parseInt(fromParts[0]) * 60 + parseInt(fromParts[1]);

							if (currentTotalMinutes < fromTotalMinutes) {
								// Before this slot opens
								return this.translate(translations.pages.cart_delivery.restaurant_closed_label_today, { value: slot.from + '-' + slot.to });
							}
						}
					}
				}
				// All exception slots passed for today - find next working day
				return this.getNextWorkingDayMessage(translations, settings, exceptionsV2, currentDayInt, now, addDays, true);
			}
		}

		// Check new working hours schedule v2
		const scheduleV2 = settings.working_hours_schedule_v2 && settings.working_hours_schedule_v2.value;
		if (scheduleV2) {
			let dayInt = currentDayInt;
			let daysAfterCurrent = -1;
			let nextWorkingHoursStr = null;

			// Find first working day/time
			for (let i = currentDayInt; i <= currentDayInt + 7; i++) {
				dayInt = i;
				if (dayInt > 7) dayInt -= 7;
				daysAfterCurrent++;

				const daySchedule = scheduleV2[dayInt];
				if (!daySchedule || daySchedule.is_closed == 1 || !daySchedule.time_slots || daySchedule.time_slots.length === 0) {
					continue; // Day is closed
				}

				const timeSlots = daySchedule.time_slots;

				// Current day - check if we're before any open slot
				if (daysAfterCurrent == 0) {
					// Find next available slot today
					for (let slot of timeSlots) {
						if (slot.from && slot.to) {
							const fromParts = slot.from.split(':');
							const toParts = slot.to.split(':');
							const fromTotalMinutes = parseInt(fromParts[0]) * 60 + parseInt(fromParts[1]);
							const toTotalMinutes = parseInt(toParts[0]) * 60 + parseInt(toParts[1]);

							if (currentTotalMinutes < fromTotalMinutes) {
								// Before this slot opens
								nextWorkingHoursStr = slot.from + '-' + slot.to;
								break;
							} else if (currentTotalMinutes >= fromTotalMinutes && currentTotalMinutes <= toTotalMinutes) {
								// Within this slot (shouldn't happen if disabledOrdering was true)
								nextWorkingHoursStr = slot.from + '-' + slot.to;
								break;
							}
							// After this slot, check next
						}
					}
					if (nextWorkingHoursStr) break;
					// All slots passed for today, continue to next day
				} else {
					// Other day - use first time slot
					nextWorkingHoursStr = timeSlotsToString(timeSlots);
					break;
				}
			}

			let nextWorkingDate = addDays(new Date(), daysAfterCurrent);
			let nextWorkingDateDay = nextWorkingDate.getDay();
			if (nextWorkingDateDay == 0) nextWorkingDateDay = 7;

			// Disabled without any working hours
			if (!nextWorkingHoursStr) {
				return this.translate(translations.pages.cart_delivery.restaurant_closed_label);
			}

			// Disabled with info when will work again
			if (daysAfterCurrent == 0) {
				return this.translate(translations.pages.cart_delivery.restaurant_closed_label_today, { value: nextWorkingHoursStr });
			} else if (daysAfterCurrent == 1) {
				return this.translate(translations.pages.cart_delivery.restaurant_closed_label_tommorow, { value: nextWorkingHoursStr });
			} else {
				return this.translate(translations.pages.cart_delivery.restaurant_closed_label_day, { day: translations.common.date.day[nextWorkingDateDay], value: nextWorkingHoursStr });
			}
		}

		// Fallback to old working_hours setting
		let working_hours = this.getSettingsValue(settings, 'working_hours');
		if (!working_hours) {
			return this.translate(translations.pages.cart_delivery.restaurant_closed_label);
		}

		let nextWorkingDay = working_hours[currentDayInt];
		let dayInt = currentDayInt;
		let daysAfterCurrent = -1;

		for (let i = currentDayInt; i <= currentDayInt + 7; i++) {
			dayInt = i;
			if (dayInt > 7) dayInt -= 7;
			daysAfterCurrent++;

			nextWorkingDay = working_hours[dayInt];

			if (nextWorkingDay == '-' || !nextWorkingDay) {
				continue;
			} else {
				let working_hours_splited = nextWorkingDay.split('-');

				const minPickupTime = working_hours_splited[0];
				const minPickupTimeHours = parseInt(minPickupTime.split(':')[0]);
				const minPickupTimeMinutes = parseInt(minPickupTime.split(':')[1]);

				const maxPickupTime = working_hours_splited[1];
				const maxPickupTimeHours = parseInt(maxPickupTime.split(':')[0]);
				const maxPickupTimeMinutes = parseInt(maxPickupTime.split(':')[1]);

				// Current day
				if (daysAfterCurrent == 0) {
					if (currentHour < minPickupTimeHours) {
						break;
					} else {
						if (currentHour == minPickupTimeHours && currentMinutes < minPickupTimeMinutes) {
							break;
						} else if (currentHour == maxPickupTimeHours && currentMinutes > maxPickupTimeMinutes) {
							//Do NOT break, Find next working
						}
					}
				} else {
					// Other day (not today) - found hours
					if (nextWorkingDay != '-') {
						break;
					}
				}
			}

		}

		let nextWorkingDate = addDays(new Date(), daysAfterCurrent);
		let nextWorkingDateDay = nextWorkingDate.getDay();
		if (nextWorkingDateDay == 0) nextWorkingDateDay = 7;

		// Disabled without any working hours
		if (nextWorkingDay == '-' || !nextWorkingDay) {
			return this.translate(translations.pages.cart_delivery.restaurant_closed_label);
		}

		// Disabled with info when will work again
		if (daysAfterCurrent == 0) {
			return this.translate(translations.pages.cart_delivery.restaurant_closed_label_today, { value: nextWorkingDay });
		} else if (daysAfterCurrent == 1) {
			return this.translate(translations.pages.cart_delivery.restaurant_closed_label_tommorow, { value: nextWorkingDay });
		} else {
			return this.translate(translations.pages.cart_delivery.restaurant_closed_label_day, { day: translations.common.date.day[nextWorkingDateDay], value: nextWorkingDay });
		}

	}

	// Product ingredients
	static getCartProductQuantity(product_variant_id, selectedIngredients) {
		var to_order = cartStorage().getItem('to_order');//setItem('token', token)
		to_order = JSON.parse(to_order);
		let foundSameIngredients = -1;
		let cartProductQuantity = 1;
		// console.log('to_order', to_order)
		if (to_order && Object.values(to_order).length > 0) {
			Object.values(to_order).map(o => {
				// console.log('ooooooooooooooh', o)
				foundSameIngredients = o.find(i => ((i.product_variant_id == product_variant_id) && (parseInt(i.ingredients.required) == parseInt(selectedIngredients.required) && (parseInt(i.ingredients.required2 || 0) == parseInt(selectedIngredients.required2 || 0)) && (isEqual(sortBy(i.ingredients.addable), sortBy(selectedIngredients.addable)) && (isEqual(sortBy(i.ingredients.removable), sortBy(selectedIngredients.removable))) && (Utils.getGroupsSignature(i.ingredients.groups) == Utils.getGroupsSignature(selectedIngredients.groups))))));
				if (foundSameIngredients) {
					cartProductQuantity = parseInt(foundSameIngredients.quantity) + 1
				}
			})
		}
		// console.log('cartProductQuantity', cartProductQuantity)
		return cartProductQuantity;
	}


	static differentIngridients(product_variant_id, selectedIngredients) {
		// console.log('product_variant_id', product_variant_id)
		// console.log('selectedIngredients', selectedIngredients)
		var to_order = cartStorage().getItem('to_order');//setItem('token', token)
		to_order = JSON.parse(to_order);

		let differentIngridients = false;
		if (to_order && Object.values(to_order).length > 0) {
			// console.log('to_order', to_order)
			Object.values(to_order).map(o => {
				// console.log('real o', o)

				// console.log('o.length', o.length)
				// console.log('o.filter(op=>op.product_variant_id == product_variant_id', o.filter(op => op.product_variant_id == product_variant_id));

				if (o.filter(op => op.product_variant_id == product_variant_id).length == 1) {
					// console.log('1 e')
					// console.log('o[0]', o[0])
					// console.log('o[0].ingredients', o[0].ingredients)
					// console.log('parseInt(o[0].product_variant_id) == parseInt(product_variant_id', parseInt(o[0].product_variant_id) == parseInt(product_variant_id));
					// console.log('parseInt(o[0].ingredients.required) == parseInt(selectedIngredients.required)', parseInt(o[0].ingredients.required) == parseInt(selectedIngredients.required))
					// console.log('isEqual(sortBy(o[0].ingredients.addable), sortBy(selectedIngredients.addable))', isEqual(sortBy(o[0].ingredients.addable), sortBy(selectedIngredients.addable)))
					// console.log('isEqual(sortBy(o[0].ingredients.removable), sortBy(selectedIngredients.removable))', isEqual(sortBy(o[0].ingredients.removable), sortBy(selectedIngredients.removable)))

					if (parseInt(o[0].product_variant_id) == parseInt(product_variant_id)
						&&

						(Object.values(o[0].ingredients).length == 0 ||
							(parseInt(o[0].ingredients.required) == parseInt(selectedIngredients.required) && parseInt(o[0].ingredients.required2 || 0) == parseInt(selectedIngredients.required2 || 0)
								&& (isEqual(sortBy(o[0].ingredients.addable), sortBy(selectedIngredients.addable)))
								&& (isEqual(sortBy(o[0].ingredients.removable), sortBy(selectedIngredients.removable)))
								&& (Utils.getGroupsSignature(o[0].ingredients.groups) == Utils.getGroupsSignature(selectedIngredients.groups))
							)
						)
					) {

						differentIngridients = true;
						// console.log('imago 1')
					}

				} else if (o.filter(op => op.product_variant_id == product_variant_id).length > 1) {
					// console.log('nee 1')
					Object.values(o).map(oo => {
						if (parseInt(oo.product_variant_id) == parseInt(product_variant_id)
							&& parseInt(oo.ingredients.required) == parseInt(selectedIngredients.required) && parseInt(oo.ingredients.required2 || 0) == parseInt(selectedIngredients.required2 || 0)
							&& (isEqual(sortBy(oo.ingredients.addable), sortBy(selectedIngredients.addable)))
							&& (isEqual(sortBy(oo.ingredients.removable), sortBy(selectedIngredients.removable)))
							&& (Utils.getGroupsSignature(oo.ingredients.groups) == Utils.getGroupsSignature(selectedIngredients.groups))
						) {

							differentIngridients = true;
							// console.log('imago 2')
						}
					})
				}

			})
		}
		// console.log('razlichen li e :', !differentIngridients)
		return !differentIngridients;

	}

	static setDataForTrack(cat_id, prod_id, location) {
		let tabl_tracking = {
			"prev_cat": cat_id, //store.getState().categories.selected_cat_hierarchy_id || 0,
			"prev_prod": prod_id, //store.getState().products.view_product_page_id || 0
			"location": location
		}

		window.localStorage.setItem("tabl_tracking", JSON.stringify(tabl_tracking));
	}

	static getDataForTrack() {
		let catAndProd = window.localStorage.getItem("tabl_tracking");

		if (catAndProd) {
			return JSON.parse(catAndProd);
		} else {
			return null;
		}
	}

	static clearDataForTrack() {
		window.localStorage.removeItem("tabl_tracking");
	}

	static sortPriority = (asc = true) => {
		return function (a, b) {
			let priorityOne = a.priority * 1;
			let priorityTwo = b.priority * 1;
			// equal items sort equally
			// if (a === b) {
			//     return 0;
			// }
			// // nulls sort after anything else
			// if (priorityOne === 0) {
			// 	return 1;
			// }
			// else if (priorityTwo === 0) {
			// 	return -1;
			// }
			// // otherwise, if we're ascending, lowest sorts first
			// return priorityOne < priorityTwo ? -1 : 1;

			return (priorityOne < priorityTwo) ? -1 : ((priorityOne > priorityTwo) ? 1 : 0);

		};
	}

	static sortName = (asc = true, column = 'name') => {
		return function (a, b) {
			var nameA = a[column].toUpperCase(); // ignore upper and lowercase
			var nameB = b[column].toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		}
	}


	static normalizeCartProducts = (cartProducts = []) => {
		let newp = [];

		Object.values(cartProducts).map(p => {
			newp = newp.concat(p)
		})

		return newp;

	}


	// Each price for each product - List products
	static calculateProductPriceListingProducts = (productVariantPrice, discountPercent, discountMoney, settings) => {
		let calculatedProductPrice = productVariantPrice;

		if (discountPercent) {
			calculatedProductPrice = (parseFloat(calculatedProductPrice - ((parseFloat(discountPercent) * parseFloat(calculatedProductPrice)) / 100))).toFixed(2);
		}

		if (settings && settings.calculate_product_discount_money_only_for_preorder_orders && settings.calculate_product_discount_money_only_for_preorder_orders.value && settings.calculate_product_discount_money_only_for_preorder_orders.value == 1) {
			// Do not calculate discount money on listing page, if there is a setting to calculate it only for preorder
		} else {
			if (discountMoney) {
				calculatedProductPrice = parseFloat(calculatedProductPrice - parseFloat(discountMoney)).toFixed(2);
			}
		}


		// TODO - add price for default required ingredient

		return calculatedProductPrice;

	}

	// Ingredients
	static getIngredientNamesByIds = (ingredientIds, productIngredients) => {
		// const { productIngredients } = this.props;
		// console.log('checking for: ', ingredientIds)
		let ingredientsNames = '';
		if (productIngredients && Object.values(productIngredients).length) {
			// debugger;
			if (Array.isArray(ingredientIds)) {
				// console.log('arr')
				Object.values(ingredientIds).map((i, k) => {
					// console.log('map: ', i, ' ', k)

					if (productIngredients[i] && productIngredients[i].name) {
						if (k != 0) {
							ingredientsNames += ', ';
						}
						ingredientsNames += productIngredients[i].name;
					}
					// console.log('ingredientsNames: ', ingredientsNames)
				})
			} else {
				// console.log('elsa')
				if (productIngredients && productIngredients[parseInt(ingredientIds)] && productIngredients[parseInt(ingredientIds)].name) {
					ingredientsNames += productIngredients[parseInt(ingredientIds)].name;
				}
				// console.log('ingredientsNames :', ingredientsNames)
			}
		}

		return ingredientsNames;
	}

	static addIngredientsPrice = (item, productIngredients) => {
		let ingredientsPrice = 0;
		// console.log('item INGR', item)
		// console.log('productIngredients', productIngredients)
		// console.log('parseInt(item.ingredients.required)', parseInt(item.ingredients.required))
		// console.log('item.product_ingredients', item.product_ingredients)
		// console.log('productIngredients', productIngredients)
		if (item && item.ingredients && item.product_ingredients && Object.values(item.product_ingredients).length > 0 && productIngredients) {
			if (item.ingredients.required) {
				if (productIngredients && productIngredients[parseInt(item.ingredients.required)] && productIngredients[parseInt(item.ingredients.required)].price) {
					// console.log('adding: productIngredients[parseInt(item.ingredients.required)].price', productIngredients[parseInt(item.ingredients.required)].price)
					ingredientsPrice += parseFloat(productIngredients[parseInt(item.ingredients.required)].price);
				}
			}

			if (item.ingredients.required2) {
				if (productIngredients && productIngredients[parseInt(item.ingredients.required2)] && productIngredients[parseInt(item.ingredients.required2)].price) {
					ingredientsPrice += parseFloat(productIngredients[parseInt(item.ingredients.required2)].price);
				}
			}

			if (item.ingredients.addable) {
				Object.values(item.ingredients.addable).map(ingrId => {
					if (productIngredients && productIngredients[parseInt(ingrId)] && productIngredients[parseInt(ingrId)].price) {
						// console.log('adding: productIngredients[parseInt(ingrId)].price', productIngredients[parseInt(ingrId)].price)
						ingredientsPrice += parseFloat(productIngredients[parseInt(ingrId)].price);
					}
				})
			}

			// if (item.ingredients.removable) {
			//     Object.values(item.ingredients.removable).map(ingrId => {
			//         if (this.props.productIngredients && this.props.productIngredients[parseInt(ingrId)] && this.props.productIngredients[parseInt(ingrId)].price) {
			//             console.log('adding: this.props.productIngredients[parseInt(ingrId)].price', this.props.productIngredients[parseInt(ingrId)].price)
			//             ingredientsPrice += parseFloat(this.props.productIngredients[parseInt(ingrId)].price);
			//         }
			//     })
			// }

		}

		// Конфигурируеми групи. Гледа се направо item.ingredients.groups (без условието за
		// product_ingredients по-горе), защото стойността е самодостатъчна. Продукт без
		// групи добавя 0.00 - точно както преди.
		if (item && item.ingredients && productIngredients) {
			ingredientsPrice += this.addIngredientGroupsPrice(item.ingredients.groups, productIngredients);
		}

		return ingredientsPrice;
	}

	// -> [{ groupId, picks: [{ ingredientId, qty }] }]. Приема и { "12": [45, 47] },
	// и { "12": [{id: 45, qty: 2}] } - огледало на app/helpers/ingredientGroups.js на бекенда.
	static normalizeGroupSelections = (groups) => {
		if (!groups || typeof groups != 'object') return [];

		const result = [];
		Object.keys(groups).map(key => {
			const groupId = parseInt(key);
			if (!groupId) return;

			let picks = groups[key];
			if (!picks && picks !== 0) return;
			if (!Array.isArray(picks)) picks = [picks];

			const byIngredient = {};
			const normalized = [];
			picks.map(pick => {
				const isObject = pick && typeof pick == 'object';
				const ingredientId = parseInt(isObject ? (pick.ingredientId || pick.id) : pick);
				if (!ingredientId) return;

				let qty = isObject ? parseInt(pick.qty || pick.quantity || 1) : 1;
				if (!qty || qty < 1) qty = 1;

				if (byIngredient[ingredientId]) {
					byIngredient[ingredientId].qty += qty;
					return;
				}
				byIngredient[ingredientId] = { ingredientId: ingredientId, qty: qty };
				normalized.push(byIngredient[ingredientId]);
			});

			if (normalized.length === 0) return;
			result.push({ groupId: groupId, picks: normalized });
		});

		return result;
	}

	// Конфигурируемите групи на един продукт, подредени както са в админа.
	static getIngredientGroupsForProduct = (productId) => {
		const state = store.getState();
		const groups = (state.products && state.products.ingredientGroups) || {};

		return Object.values(groups)
			.filter(group => group && parseInt(group.productId) === parseInt(productId))
			.filter(group => group.options && group.options.length > 0)
			.sort((a, b) => (parseFloat(a.priority) || 0) - (parseFloat(b.priority) || 0) || a.id - b.id);
	}

	// Стойност по подразбиране за бързото добавяне (бутонът "+" в списъка, банерът за
	// бърза поръчка, повторната поръчка), където няма къде да се избира. Взима първите
	// опции на всяка ЗАДЪЛЖИТЕЛНА група - същото, което правят required и required2 от години.
	// Групите по избор остават празни. Така поръчката винаги минава валидацията на сървъра.
	static getDefaultGroupSelections = (productId) => {
		const state = store.getState();
		const productIngredients = (state.products && state.products.productIngredients) || {};
		const selections = {};

		this.getIngredientGroupsForProduct(productId).map(group => {
			const min = parseInt(group.min_select) || 0;
			if (min === 0) return;

			const picks = [];
			group.options.map(option => {
				if (picks.length >= min) return;
				const ingredient = productIngredients[option.ingredientId];
				if (!ingredient || ingredient.active == false) return;
				picks.push({ id: parseInt(option.ingredientId), qty: 1 });
			});

			if (picks.length > 0) {
				selections[group.id] = picks;
			}
		});

		return selections;
	}

	// Общ брой избрани бройки в група (2x кюфте = 2).
	static countGroupUnits = (picks) => {
		return (picks || []).reduce((sum, pick) => sum + (parseInt(pick.qty) || 1), 0);
	}

	static addIngredientGroupsPrice = (groups, productIngredients) => {
		let price = 0;

		this.normalizeGroupSelections(groups).map(selection => {
			selection.picks.map(pick => {
				const ingr = productIngredients && productIngredients[pick.ingredientId];
				if (ingr && ingr.price) {
					price += parseFloat(ingr.price) * pick.qty;
				}
			});
		});

		return price;
	}

	// Еднозначен отпечатък на избраните групи - използва се за сравняване на два реда в
	// количката. Сортира се, за да не зависи от реда на кликане.
	static getGroupsSignature = (groups) => {
		return this.normalizeGroupSelections(groups)
			.map(selection => selection.groupId + ':' + selection.picks
				.map(pick => pick.ingredientId + 'x' + pick.qty)
				.sort()
				.join(','))
			.sort()
			.join('|');
	}

	// Същото, но за ВЕЧЕ направена поръчка: чете се от opv_ingredients, където заглавието
	// на групата е снимка (group_name) отпреди евентуално преименуване.
	static getGroupedOpvIngredientLines = (opvIngredients, productIngredients) => {
		const groups = [];
		const byName = {};

		Object.values(opvIngredients || {}).map(ing => {
			if (!ing || !ing.group_name) return;

			const ingredient = productIngredients && productIngredients[ing.ingredientId];
			const name = (ing.ingredient && ing.ingredient.name) || (ingredient && ingredient.name) || '';
			if (!name) return;

			if (!byName[ing.group_name]) {
				byName[ing.group_name] = [];
				groups.push({ name: ing.group_name, items: byName[ing.group_name] });
			}

			const qty = parseInt(ing.quantity) || 1;
			byName[ing.group_name].push(qty > 1 ? name + ' x' + qty : name);
		});

		return groups.map(group => group.name + ': ' + group.items.join(', '));
	}

	// "Протеин: Пилешко бон филе" / "Зеленчуци: Домат x2, Авокадо" за количката.
	static getGroupedSelectionLines = (groups, productIngredients, ingredientGroups) => {
		return this.normalizeGroupSelections(groups).map(selection => {
			const group = ingredientGroups && ingredientGroups[selection.groupId];

			const names = selection.picks
				.map(pick => {
					const ingr = productIngredients && productIngredients[pick.ingredientId];
					if (!ingr || !ingr.name) return '';
					return pick.qty > 1 ? ingr.name + ' x' + pick.qty : ingr.name;
				})
				.filter(name => name.length > 0);

			if (names.length === 0) return '';
			return (group && group.name ? group.name + ': ' : '') + names.join(', ');
		}).filter(line => line.length > 0);
	}

	// Base nutrition for a product+variant: the product value PLUS the variant value
	// (both treated as additive; null/empty counts as 0). So a product with 100 kcal and a
	// variant with 10 kcal yields 110 kcal. Returns {kcal, protein, carbs, fat}.
	static getBaseNutrition = (product, variant) => {
		const keys = ['kcal', 'protein', 'carbs', 'fat'];
		const out = { kcal: 0, protein: 0, carbs: 0, fat: 0 };
		keys.forEach(k => {
			const p = product && product[k] != null && !isNaN(parseFloat(product[k])) ? parseFloat(product[k]) : 0;
			const v = variant && variant[k] != null && !isNaN(parseFloat(variant[k])) ? parseFloat(variant[k]) : 0;
			out[k] = p + v;
		});
		return out;
	}

	// Sum of nutrition added by the selected ingredients/extras (e.g. tomatoes) of a cart item.
	// Mirrors addIngredientsPrice: required + addable selections, looked up in the global
	// productIngredients list (which carries kcal/protein/carbs/fat per ingredient).
	static addIngredientsNutrition = (item, productIngredients) => {
		let nutrition = { kcal: 0, protein: 0, carbs: 0, fat: 0 };
		const keys = ['kcal', 'protein', 'carbs', 'fat'];

		const addFromIngredient = (ingrId) => {
			const ingr = productIngredients && productIngredients[parseInt(ingrId)];
			if (!ingr) return;
			keys.forEach(k => {
				if (ingr[k] != null && !isNaN(parseFloat(ingr[k]))) {
					nutrition[k] += parseFloat(ingr[k]);
				}
			});
		};

		if (item && item.ingredients && item.product_ingredients && Object.values(item.product_ingredients).length > 0 && productIngredients) {
			if (item.ingredients.required) {
				addFromIngredient(item.ingredients.required);
			}
			if (item.ingredients.required2) {
				addFromIngredient(item.ingredients.required2);
			}
			if (item.ingredients.addable) {
				Object.values(item.ingredients.addable).map(ingrId => addFromIngredient(ingrId));
			}
		}

		// Конфигурируеми групи - всяка бройка добавя своите калории/протеин (2x кюфте = 2x).
		if (item && item.ingredients && productIngredients) {
			this.normalizeGroupSelections(item.ingredients.groups).map(selection => {
				selection.picks.map(pick => {
					for (let i = 0; i < pick.qty; i++) {
						addFromIngredient(pick.ingredientId);
					}
				});
			});
		}

		return nutrition;
	}

	// Total nutrition for a single cart line = (base product/variant + selected extras) * quantity.
	// Returns rounded values; base nutrition is stored on the cart item at add-time (Utils-fed
	// from variant with product fallback). forceQuantity overrides the line quantity (like price helpers).
	static calculateProductNutritionOrder = (item, productIngredients, forceQuantity) => {
		const keys = ['kcal', 'protein', 'carbs', 'fat'];
		const quantity = forceQuantity ? forceQuantity : (item && item.quantity ? item.quantity : 1);
		const extras = this.addIngredientsNutrition(item, productIngredients);

		let nutrition = { kcal: 0, protein: 0, carbs: 0, fat: 0 };
		keys.forEach(k => {
			const base = item && item[k] != null && !isNaN(parseFloat(item[k])) ? parseFloat(item[k]) : 0;
			nutrition[k] = (base + extras[k]) * quantity;
		});

		return {
			kcal: parseFloat(nutrition.kcal.toFixed(1)),
			protein: parseFloat(nutrition.protein.toFixed(1)),
			carbs: parseFloat(nutrition.carbs.toFixed(1)),
			fat: parseFloat(nutrition.fat.toFixed(1)),
		};
	}

	// Whether a cart line carries any nutrition data at all (base or via selected extras),
	// so the UI can hide the block entirely when nothing is set.
	static hasNutritionData = (item, productIngredients) => {
		const n = this.calculateProductNutritionOrder(item, productIngredients, 1);
		return n.kcal > 0 || n.protein > 0 || n.carbs > 0 || n.fat > 0;
	}

	// Total nutrition across the whole order/cart.
	static calculateTotalNutritionForOrder = (products, productIngredients) => {
		let total = { kcal: 0, protein: 0, carbs: 0, fat: 0 };
		Object.values(products).map((item) => {
			const n = this.calculateProductNutritionOrder(item, productIngredients, 0);
			total.kcal += n.kcal;
			total.protein += n.protein;
			total.carbs += n.carbs;
			total.fat += n.fat;
		});
		return {
			kcal: parseFloat(total.kcal.toFixed(1)),
			protein: parseFloat(total.protein.toFixed(1)),
			carbs: parseFloat(total.carbs.toFixed(1)),
			fat: parseFloat(total.fat.toFixed(1)),
		};
	}


	// Each price for each product - Cart modal
	/*
		@forceQuantity - Used when you have to know the price of that product, if passed '1' the current product quantity is not valid and not calculated
	*/


	// Опаковката на ред в количката ("Кутия супа", 1.00). Приоритет: собствената опаковка на продукта
	// (item.packaging, ако е зададена) печели пред тази на категорията (собствена или наследена от родителя;
	// сървърът я подава с категориите). null, ако няма опаковка.
	static getCategoryPackagingForCartItem = (item) => {
		if (!item) return null;

		// 1) Собствена опаковка на продукта (пренася се в реда при добавяне в количката).
		if (item.packaging && parseFloat(item.packaging.price) > 0) {
			return { name: item.packaging.name, price: parseFloat(item.packaging.price) };
		}

		// 2) Опаковка на категорията.
		if (!item.catHierarchyId) return null;
		const categories = store.getState().categories.categories_hierarchy || {};
		const cat = categories[item.catHierarchyId];
		const packaging = cat && cat.packaging ? cat.packaging : null;

		return packaging && parseFloat(packaging.price) > 0 ? { name: packaging.name, price: parseFloat(packaging.price) } : null;
	}

	// Кутия на ред от вече направена поръчка, цена за брой: записаната в поръчката (box_price, 0 = без кутия),
	// а при по-стари поръчки - цената на кутия от варианта, ако обектът показва кутиите.
	static getOpvBoxPrice = (opv, settings) => {
		if (!opv) return 0;

		if (opv.box_price !== null && opv.box_price !== undefined) {
			return parseFloat(opv.box_price) || 0;
		}

		const additional_price = opv.product_variant ? opv.product_variant.additional_price : 0;
		return this.getSettingsValue(settings, 'show_variant_additional_price') == 1 ? (parseFloat(additional_price) || 0) : 0;
	}

	static calculateBoxesForProducts = (products, settings, ordertype, productIngredients, forceQuantity, calculateAdditionalPrice = true) => {
		let totalCartPrice = 0;

		Object.values(products).map((item, k) => {
			const quantity = item.quantity;
			const additional_price = item.additional_price ? item.additional_price : item.product_variant ? item.product_variant.additional_price : 0;

			// Product quantity
			let productQuantity = forceQuantity ? forceQuantity : quantity;
			const calculate_product_box_only_for_preorder_orders = this.getSettingsValue(settings, 'calculate_product_box_only_for_preorder_orders')

			const show_variant_additional_price = this.getSettingsValue(settings, 'show_variant_additional_price');

			// BOX
			if (calculateAdditionalPrice
				&& (show_variant_additional_price == 1)
				&&
				(
					(calculate_product_box_only_for_preorder_orders == 1 && ordertype == 'preorder')
					|| (calculate_product_box_only_for_preorder_orders != 1)
				)

				&& (((parseFloat(additional_price)).toFixed(2)) != '0.00')
			) {
				totalCartPrice += parseFloat(additional_price) * 1 * quantity;
			}

			// Опаковка от категорията ("Кутия супа") - само ако вариантът няма своя кутия и само за типовете поръчки,
			// за които сървърът я таксува: взимане винаги, доставка - освен ако кутиите са само за взимане.
			if (calculateAdditionalPrice
				&& !(parseFloat(additional_price) > 0)
				&& (ordertype == 'preorder' || (ordertype == 'delivery' && calculate_product_box_only_for_preorder_orders != 1))
			) {
				const packaging = this.getCategoryPackagingForCartItem(item);
				if (packaging) {
					totalCartPrice += packaging.price * quantity;
				}
			}

		})
		return parseFloat(totalCartPrice).toFixed(2);
	}



	static calculateOrderDiscountMoneyForProducts = (products, settings, productIngredients, forceQuantity, calculateAdditionalPrice = true) => {
		let totalDiscountMoney = 0;

		Object.values(products).map((item, k) => {
			const quantity = item.quantity;
			// const additional_price = item.additional_price ? item.additional_price : item.product_variant ? item.product_variant.additional_price : 0;
			const discount_money = parseFloat(item.discount_money)

			totalDiscountMoney += parseFloat(discount_money) * parseInt(quantity);

			// // Product quantity
			// let productQuantity = forceQuantity ? forceQuantity : quantity;

			// // BOX
			// if (calculateAdditionalPrice && (settings.show_variant_additional_price && settings.show_variant_additional_price.value && settings.show_variant_additional_price.value == 1) && (settings.calculate_product_box_only_for_preorder_orders && settings.calculate_product_box_only_for_preorder_orders.value && settings.calculate_product_box_only_for_preorder_orders.value == 1) && (((parseFloat(additional_price)).toFixed(2)) != '0.00')) {
			// 	totalCartPrice += parseFloat(additional_price) * 1 * productQuantity;
			// }

		})

		return parseFloat(totalDiscountMoney).toFixed(2);
	}

	// static calculateOrderDiscountMoneyForCategories = (products, settings) => {
	// 	// let totalDiscountMoney = 0;
	// 	let catHierarchyArr = []
	// 	// console.log('products', products);
	// 	// return;

	// 	// Object.values(products).map((item, k) => {
	// 	// 	if (item && item.catHierarchyId && item.catHierarchyId.includes(catHierarchyArr)) {
	// 	// 		totalDiscountMoney++;
	// 	// 	} else {
	// 	// 		catHierarchyArr.push(item.catHierarchyId);
	// 	// 	}
	// 	// })

	// 	Object.values(products).forEach((item) => {
	// 		if (item && item.catHierarchyId) {
	// 			// ако тази категория все още я няма в масива – добавяме я
	// 			if (!catHierarchyArr.includes(item.catHierarchyId)) {
	// 				catHierarchyArr.push(item.catHierarchyId);
	// 			}
	// 		}
	// 	});

	// 	// отстъпка на категория (примерно от настройките)
	// 	const discountPerCategory = parseFloat(this.getSettingsValue(settings, 'add_discount_for_each_category_amount') || 0);

	// 	// обща отстъпка = брой уникални категории × отстъпка за категория
	// 	const totalDiscountMoney = catHierarchyArr.length * discountPerCategory;

	// 	return parseFloat(parseFloat(totalDiscountMoney).toFixed(2));
	// }



	// static calculateProductPriceOrder = (item, settings, productIngredients, forceQuantity, calculateAdditionalPrice = true, orderType = null) => {
	// 	let totalCartPrice = 0;

	// 	// Cart price structure / Order price structure
	// 	const price = item.price ? item.price : item.product_variant ? item.product_variant.price : 0;
	// 	const discount_percent = item.discount_percent;
	// 	const discount_money = item.discount_money;
	// 	const quantity = item.quantity;
	// 	const additional_price = item.additional_price ? item.additional_price : item.product_variant ? item.product_variant.additional_price : 0;

	// 	//Product discount
	// 	let productPrice;
	// 	const calculate_product_discount_money_only_for_preorder_orders = this.getSettingsValue(settings, 'calculate_product_discount_money_only_for_preorder_orders');
	// 	if (calculate_product_discount_money_only_for_preorder_orders == '1') {
	// 		if (orderType == 'preorder') {
	// 			productPrice = this.calculateProductPriceListingProducts(price, discount_percent, discount_money);
	// 		} else {
	// 			productPrice = this.calculateProductPriceListingProducts(price, discount_percent);
	// 		}
	// 	} else {
	// 		productPrice = this.calculateProductPriceListingProducts(price, discount_percent, discount_money);
	// 	}

	// 	// Product quantity
	// 	let productQuantity = forceQuantity ? forceQuantity : quantity;

	// 	//ingredients
	// 	totalCartPrice += (parseFloat(productPrice) + parseFloat(this.addIngredientsPrice(item, productIngredients))) * 1 * productQuantity;

	// 	// BOX
	// 	if (calculateAdditionalPrice && (settings.show_variant_additional_price && settings.show_variant_additional_price.value && settings.show_variant_additional_price.value == 1) && (settings.calculate_product_box_only_for_preorder_orders && settings.calculate_product_box_only_for_preorder_orders.value && settings.calculate_product_box_only_for_preorder_orders.value != 1) && (((parseFloat(additional_price)).toFixed(2)) != '0.00')) {
	// 		totalCartPrice += parseFloat(additional_price) * 1 * productQuantity;
	// 	}

	// 	return parseFloat(totalCartPrice).toFixed(2);

	// }

	// static calculateProductPriceOrder = (item, settings, productIngredients, forceQuantity, calculateAdditionalPrice = true, orderType = null) => {
	// 	let totalCartPrice = 0;

	// 	// Cart price structure / Order price structure
	// 	const price = item.price ? item.price : item.product_variant ? item.product_variant.price : 0;
	// 	let discount_percent = item.discount_percent;
	// 	const discount_money = item.discount_money;
	// 	const quantity = item.quantity;
	// 	const additional_price = item.additional_price ? item.additional_price : item.product_variant ? item.product_variant.additional_price : 0;

	// 	// Проверка за времева отстъпка и презаписване на discount_percent
	// 	if (item.time_based_discount_enabled || (item.product && item.product.time_based_discount_enabled)) {
	// 		const product = item.product || item; // взимаме продукта от където е наличен
	// 		const now = new Date();
	// 		const currentHour = now.getHours();
	// 		const currentDay = now.getDay(); // 0 = неделя, 1 = понеделник

	// 		// Парсваме JSON данните за дните
	// 		let allowedDays = [];
	// 		try {
	// 			allowedDays = typeof product.time_based_discount_days === 'string'
	// 				? JSON.parse(product.time_based_discount_days)
	// 				: product.time_based_discount_days || [];
	// 		} catch (e) {
	// 			allowedDays = [];
	// 		}

	// 		// Проверка на ден и час
	// 		const isDayValid = allowedDays.includes(currentDay);
	// 		const startHour = product.time_based_discount_start_hour || 0;
	// 		const endHour = product.time_based_discount_end_hour || 23;

	// 		let isTimeValid = false;
	// 		if (endHour < startHour) {
	// 			isTimeValid = currentHour >= startHour || currentHour <= endHour;
	// 		} else {
	// 			isTimeValid = currentHour >= startHour && currentHour <= endHour;
	// 		}

	// 		// Ако условията са изпълнени, презаписваме discount_percent
	// 		if (isDayValid && isTimeValid) {
	// 			discount_percent = product.time_based_discount_percent || 0;
	// 		}
	// 	}

	// 	//Product discount
	// 	let productPrice;
	// 	const calculate_product_discount_money_only_for_preorder_orders = this.getSettingsValue(settings, 'calculate_product_discount_money_only_for_preorder_orders');
	// 	if (calculate_product_discount_money_only_for_preorder_orders == '1') {
	// 		if (orderType == 'preorder') {
	// 			productPrice = this.calculateProductPriceListingProducts(price, discount_percent, discount_money);
	// 		} else {
	// 			productPrice = this.calculateProductPriceListingProducts(price, discount_percent);
	// 		}
	// 	} else {
	// 		productPrice = this.calculateProductPriceListingProducts(price, discount_percent, discount_money);
	// 	}

	// 	// Product quantity
	// 	let productQuantity = forceQuantity ? forceQuantity : quantity;

	// 	//ingredients
	// 	totalCartPrice += (parseFloat(productPrice) + parseFloat(this.addIngredientsPrice(item, productIngredients))) * 1 * productQuantity;

	// 	// BOX
	// 	if (calculateAdditionalPrice && (settings.show_variant_additional_price && settings.show_variant_additional_price.value && settings.show_variant_additional_price.value == 1) && (settings.calculate_product_box_only_for_preorder_orders && settings.calculate_product_box_only_for_preorder_orders.value && settings.calculate_product_box_only_for_preorder_orders.value != 1) && (((parseFloat(additional_price)).toFixed(2)) != '0.00')) {
	// 		totalCartPrice += parseFloat(additional_price) * 1 * productQuantity;
	// 	}

	// 	return parseFloat(totalCartPrice).toFixed(2);
	// }


	static calculateOrderDiscountMoneyForCategories = (products, settings, promocodeData = null) => {
		// ПРОВЕРКА: Ако има промокод с ignore_other_discounts = 1, НЕ смятаме category discount
		if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.ignore_other_discounts) {
			return 0;
		}

		let catHierarchyArr = []

		Object.values(products).forEach((item) => {
			if (item && item.catHierarchyId) {
				if (!catHierarchyArr.includes(item.catHierarchyId)) {
					catHierarchyArr.push(item.catHierarchyId);
				}
			}
		});

		const discountPerCategory = parseFloat(this.getSettingsValue(settings, 'add_discount_for_each_category_amount') || 0);
		const totalDiscountMoney = catHierarchyArr.length * discountPerCategory;

		return parseFloat(parseFloat(totalDiscountMoney).toFixed(2));
	}

	static calculateProductPriceOrder = (item, settings, productIngredients, forceQuantity, calculateAdditionalPrice = true, orderType = null, promocodeData = null) => {
		let totalCartPrice = 0;

		// Cart price structure / Order price structure
		const price = item.price ? item.price : item.product_variant ? item.product_variant.price : 0;
		let discount_percent = item.discount_percent;
		const discount_money = item.discount_money;
		const quantity = item.quantity;
		const additional_price = item.additional_price ? item.additional_price : item.product_variant ? item.product_variant.additional_price : 0;

		// ПРОВЕРКА: Ако има промокод с ignore_other_discounts = 1, НЕ прилагаме product discounts
		let shouldApplyProductDiscounts = true;
		if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.ignore_other_discounts) {
			shouldApplyProductDiscounts = false;
		}

		// Проверка за времева отстъпка (само ако shouldApplyProductDiscounts = true)
		if (shouldApplyProductDiscounts && (item.time_based_discount_enabled || (item.product && item.product.time_based_discount_enabled))) {
			const product = item.product || item;
			const now = new Date();
			const currentHour = now.getHours();
			const currentDay = now.getDay();

			let allowedDays = [];
			try {
				allowedDays = typeof product.time_based_discount_days === 'string'
					? JSON.parse(product.time_based_discount_days)
					: product.time_based_discount_days || [];
			} catch (e) {
				allowedDays = [];
			}

			const isDayValid = allowedDays.includes(currentDay);
			const startHour = product.time_based_discount_start_hour || 0;
			const endHour = product.time_based_discount_end_hour || 23;

			let isTimeValid = false;
			if (endHour < startHour) {
				isTimeValid = currentHour >= startHour || currentHour <= endHour;
			} else {
				isTimeValid = currentHour >= startHour && currentHour <= endHour;
			}

			if (isDayValid && isTimeValid) {
				discount_percent = product.time_based_discount_percent || 0;
			}
		}

		// Product discount (само ако shouldApplyProductDiscounts = true)
		let productPrice;
		const calculate_product_discount_money_only_for_preorder_orders = this.getSettingsValue(settings, 'calculate_product_discount_money_only_for_preorder_orders');

		if (shouldApplyProductDiscounts) {
			if (calculate_product_discount_money_only_for_preorder_orders == '1') {
				if (orderType == 'preorder') {
					productPrice = this.calculateProductPriceListingProducts(price, discount_percent, discount_money);
				} else {
					productPrice = this.calculateProductPriceListingProducts(price, discount_percent);
				}
			} else {
				productPrice = this.calculateProductPriceListingProducts(price, discount_percent, discount_money);
			}
		} else {
			// Ако ignore_other_discounts = 1, използваме базовата цена без отстъпки
			productPrice = price;
		}


		// 📊 DEBUG: Детайлна информация за продукта
		// console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
		// console.log(`📦 Продукт: ${item.name}`);
		// console.log(`💰 Базова цена: ${price} лв`);
		// console.log(`🔢 Количество: ${quantity}`);
		// if (discount_percent || discount_money) {
		// 	console.log(`🎯 Product discount: ${discount_percent ? discount_percent + '%' : ''} ${discount_money ? discount_money + ' лв' : ''}`);
		// }
		// console.log(`${shouldApplyProductDiscounts ? '✅' : '❌'} Прилагат се product discounts: ${shouldApplyProductDiscounts ? 'ДА' : 'НЕ (промокодът игнорира другите отстъпки)'}`);
		// console.log(`💵 Цена след product discount: ${productPrice} лв`);
		// if (item.disable_promocode_discount == 1) {
		// 	console.log(`🚫 Продуктът БЛОКИРА промокод (disable_promocode_discount = 1)`);
		// }
		// Product quantity
		let productQuantity = forceQuantity ? forceQuantity : quantity;

		// Ingredients (винаги се добавят)
		totalCartPrice += (parseFloat(productPrice) + parseFloat(this.addIngredientsPrice(item, productIngredients))) * 1 * productQuantity;

		// BOX (винаги се добавя ако е позволено)
		if (calculateAdditionalPrice && (settings.show_variant_additional_price && settings.show_variant_additional_price.value && settings.show_variant_additional_price.value == 1) && (settings.calculate_product_box_only_for_preorder_orders && settings.calculate_product_box_only_for_preorder_orders.value && settings.calculate_product_box_only_for_preorder_orders.value != 1) && (((parseFloat(additional_price)).toFixed(2)) != '0.00')) {
			totalCartPrice += parseFloat(additional_price) * 1 * productQuantity;
		}

		// Related products attached as addons. Charged once per entry (each click = new row),
		// independent of the parent line's quantity — one click in the upsell modal = one addon paid.
		if (Array.isArray(item.addable_products) && item.addable_products.length > 0) {
			item.addable_products.forEach(addon => {
				if (!addon) return;
				const addonPrice = parseFloat(addon.price || 0);
				const addonQty = addon.qty && parseInt(addon.qty, 10) > 0 ? parseInt(addon.qty, 10) : 1;
				totalCartPrice += addonPrice * addonQty;
			});
		}

		// console.log(`💎 ФИНАЛНА ЦЕНА (x${productQuantity}): ${totalCartPrice} лв`);
		// console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

		return parseFloat(totalCartPrice).toFixed(2);
	}


	static canApplyPromocodeToProduct = (product, promocode = null) => {
		// console.log('[canApplyPromocodeToProduct] Checking product:', {
		// 	name: product.name,
		// 	disable_promocode_discount: product.disable_promocode_discount,
		// 	override_from_promocode: promocode?.payload?.override_product_discount_disable
		// });

		// Ако disable_promocode_discount = 1, НЕ позволява
		// ОСВЕН ако промокодът има override_product_discount_disable = 1
		if (product.disable_promocode_discount && product.disable_promocode_discount == 1) {
			// Проверяваме дали промокодът може да игнорира забраната
			if (promocode && promocode.payload && promocode.payload.override_product_discount_disable == 1) {
				// console.log('[canApplyPromocodeToProduct] ✅ Product allows promocode (override enabled)');
				return true; // Промокодът може да игнорира забраната
			}
			// console.log('[canApplyPromocodeToProduct] ❌ Product BLOCKS promocode');
			return false; // Промокодът не може да се приложи
		}
		// console.log('[canApplyPromocodeToProduct] ✅ Product allows promocode (no restriction)');
		return true; // Продуктът няма забрана
	}

	// Calculate total price for all products - Cart modal	
	// static calculateTotalPriceForOrder = (products, settings, productIngredients, calculateAdditionalPrice = true, orderType) => {
	// 	var totalCartPrice = 0;
	// 	Object.values(products).map((item, k) => {
	// 		totalCartPrice += parseFloat(this.calculateProductPriceOrder(item, settings, productIngredients, 0, calculateAdditionalPrice, orderType));
	// 	})

	// 	return parseFloat(totalCartPrice).toFixed(2);
	// }

	static calculateTotalPriceForOrder = (products, settings, productIngredients, calculateAdditionalPrice = true, orderType, promocodeData = null) => {
		var totalCartPrice = 0;
		Object.values(products).map((item, k) => {
			totalCartPrice += parseFloat(this.calculateProductPriceOrder(item, settings, productIngredients, 0, calculateAdditionalPrice, orderType, promocodeData));
		})

		return parseFloat(totalCartPrice).toFixed(2);
	}

	// static getOrderTypeDiscount = (choosenPlace, orderType, currentCartPrice, returnObjectInfo = false, promocodeData = []) => {

	// static getOrderTypeDiscount = (choosenPlace, orderType, currentCartPrice, returnObjectInfo = false, promocodeData = [], products = null, settings = null, productIngredients = null) => {
	// 	let now = new Date();
	// 	let currentHour = now.getHours();
	// 	let currentMinutes = now.getMinutes();
	// 	let currentSeconds = now.getSeconds();

	// 	let currentPlaceOrderType = choosenPlace && choosenPlace.ordertypes && choosenPlace.ordertypes.find(t => t.type == orderType);
	// 	let currentPlaceOrderTypeDiscount = currentPlaceOrderType && currentPlaceOrderType.discounts ? currentPlaceOrderType.discounts : [];

	// 	let negative_price = 0;
	// 	let returnObject = {};

	// 	let dateWithHoursForCompare = Date.parse('01/01/2021 ' + currentHour + ':' + currentMinutes + ':' + currentSeconds);
	// 	currentPlaceOrderTypeDiscount = currentPlaceOrderTypeDiscount.filter(d => Date.parse('01/01/2021 ' + d.active_start_time) <= dateWithHoursForCompare && dateWithHoursForCompare <= Date.parse('01/01/2021 ' + d.active_end_time))

	// 	if (promocodeData && (Object.values(promocodeData).length == 0 || (promocodeData && promocodeData.payload && promocodeData.payload.found == false) || (promocodeData && promocodeData.payload && promocodeData.payload.found && !promocodeData.payload.ignore_other_discounts))) {
	// 		currentPlaceOrderTypeDiscount
	// 			.sort((a, b) => (a.price_over - b.price_over) || (a.value - b.value))
	// 			.map((d, k) => {
	// 				if (currentCartPrice >= d.price_over && (typeof currentPlaceOrderTypeDiscount[k + 1] === "undefined" || (typeof currentPlaceOrderTypeDiscount[k + 1] !== "undefined" && currentCartPrice < currentPlaceOrderTypeDiscount[k + 1].price_over))) {
	// 					returnObject.value_type = d.value_type;
	// 					returnObject.value = d.value;

	// 					if (d.value_type == 'percent') {
	// 						negative_price += (parseFloat(d.value) * parseFloat(currentCartPrice) / 100);
	// 					} else if (d.value_type == 'money') {
	// 						negative_price += parseFloat(d.value);
	// 					}
	// 				}
	// 			})
	// 	}

	// 	// ===== FIX: Промокод отстъпка с проверка за disable_promocode_discount =====
	// 	if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.discount_value && promocodeData.payload.discount_type) {
	// 		let discountType = promocodeData.payload.discount_type;
	// 		let discountValue = promocodeData.payload.discount_value;

	// 		// Изчисляваме цена само на продукти, които позволяват промокод
	// 		let priceForPromocode = currentCartPrice - negative_price;

	// 		if (products && settings && productIngredients) {
	// 			// Филтрираме продуктите - САМО тези, които ПОЗВОЛЯВАТ промокод
	// 			let productsWithPromocode = Object.values(products).filter(p => this.canApplyPromocodeToProduct(p));

	// 			// Изчисляваме цената само на продуктите с промокод
	// 			let orderTypeForCalculation = orderType; // 'delivery' или 'preorder'
	// 			priceForPromocode = parseFloat(this.calculateTotalPriceForOrder(productsWithPromocode, settings, productIngredients, true, orderTypeForCalculation));
	// 		}

	// 		// Прилагаме отстъпката
	// 		if (discountType == 'percent') {
	// 			let calculatedDiscount = (parseFloat(discountValue) * parseFloat(priceForPromocode) / 100);
	// 			negative_price += calculatedDiscount;
	// 		} else if (discountType == 'money') {
	// 			// За money - не можем да дадем повече отстъпка от цената на продуктите
	// 			let moneyDiscount = Math.min(parseFloat(discountValue), priceForPromocode);
	// 			negative_price += moneyDiscount;
	// 		}
	// 	}

	// 	return returnObjectInfo ? returnObject : negative_price;
	// }

	// static getOrderTypeDiscount = (choosenPlace, orderType, currentCartPrice, returnObjectInfo = false, promocodeData = [], products = null, settings = null, productIngredients = null) => {
	// 	let now = new Date();
	// 	let currentHour = now.getHours();
	// 	let currentMinutes = now.getMinutes();
	// 	let currentSeconds = now.getSeconds();

	// 	let currentPlaceOrderType = choosenPlace && choosenPlace.ordertypes && choosenPlace.ordertypes.find(t => t.type == orderType);
	// 	let currentPlaceOrderTypeDiscount = currentPlaceOrderType && currentPlaceOrderType.discounts ? currentPlaceOrderType.discounts : [];

	// 	let negative_price = 0;
	// 	let returnObject = {};

	// 	let dateWithHoursForCompare = Date.parse('01/01/2021 ' + currentHour + ':' + currentMinutes + ':' + currentSeconds);
	// 	currentPlaceOrderTypeDiscount = currentPlaceOrderTypeDiscount.filter(d => Date.parse('01/01/2021 ' + d.active_start_time) <= dateWithHoursForCompare && dateWithHoursForCompare <= Date.parse('01/01/2021 ' + d.active_end_time))

	// 	// КРИТИЧНА ПРОВЕРКА: Ако има промокод с ignore_other_discounts = 1, НЕ прилагаме ordertype отстъпки
	// 	let shouldApplyOrdertypeDiscount = true;
	// 	if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.ignore_other_discounts) {
	// 		shouldApplyOrdertypeDiscount = false;
	// 	}

	// 	// Прилагаме ordertype discount само ако е позволено
	// 	if (shouldApplyOrdertypeDiscount && (Object.values(promocodeData).length == 0 || (promocodeData && promocodeData.payload && promocodeData.payload.found == false))) {
	// 		currentPlaceOrderTypeDiscount
	// 			.sort((a, b) => (a.price_over - b.price_over) || (a.value - b.value))
	// 			.map((d, k) => {
	// 				if (currentCartPrice >= d.price_over && (typeof currentPlaceOrderTypeDiscount[k + 1] === "undefined" || (typeof currentPlaceOrderTypeDiscount[k + 1] !== "undefined" && currentCartPrice < currentPlaceOrderTypeDiscount[k + 1].price_over))) {
	// 					returnObject.value_type = d.value_type;
	// 					returnObject.value = d.value;

	// 					if (d.value_type == 'percent') {
	// 						negative_price += (parseFloat(d.value) * parseFloat(currentCartPrice) / 100);
	// 					} else if (d.value_type == 'money') {
	// 						negative_price += parseFloat(d.value);
	// 					}
	// 				}
	// 			})
	// 	}

	// 	// Прилагаме promocode discount
	// 	if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.discount_value && promocodeData.payload.discount_type) {
	// 		let discountType = promocodeData.payload.discount_type;
	// 		let discountValue = promocodeData.payload.discount_value;

	// 		// Изчисляваме цената за промокод
	// 		// Ако ignore_other_discounts = 1, използваме пълната цена БЕЗ отстъпки
	// 		// Ако ignore_other_discounts = 0, използваме цената СЛЕД ordertype discount
	// 		let priceForPromocode = currentCartPrice;

	// 		if (promocodeData.payload.ignore_other_discounts) {
	// 			// Пресмятаме цената БЕЗ НИКАКВИ отстъпки
	// 			if (products && settings && productIngredients) {
	// 				priceForPromocode = parseFloat(this.calculateTotalPriceForOrder(
	// 					Object.values(products).filter(p => this.canApplyPromocodeToProduct(p)),
	// 					settings,
	// 					productIngredients,
	// 					true,
	// 					orderType,
	// 					promocodeData // Подаваме promocodeData за да може calculateProductPriceOrder да знае да не прилага отстъпки
	// 				));
	// 			}
	// 		} else {
	// 			// Използваме цената СЛЕД ordertype discount
	// 			priceForPromocode = currentCartPrice - negative_price;

	// 			if (products && settings && productIngredients) {
	// 				let productsWithPromocode = Object.values(products).filter(p => this.canApplyPromocodeToProduct(p));
	// 				priceForPromocode = parseFloat(this.calculateTotalPriceForOrder(productsWithPromocode, settings, productIngredients, true, orderType, null));

	// 				// Пропорционално намаляваме ordertype отстъпката
	// 				if (shouldApplyOrdertypeDiscount && negative_price > 0) {
	// 					let proportionalOrdertypeDiscount = negative_price * (priceForPromocode / currentCartPrice);
	// 					priceForPromocode -= proportionalOrdertypeDiscount;
	// 				}
	// 			}
	// 		}

	// 		// Прилагаме отстъпката от промокода
	// 		if (discountType == 'percent') {
	// 			let calculatedDiscount = (parseFloat(discountValue) * parseFloat(priceForPromocode) / 100);
	// 			negative_price += calculatedDiscount;
	// 		} else if (discountType == 'money') {
	// 			let moneyDiscount = Math.min(parseFloat(discountValue), Math.max(0, priceForPromocode));
	// 			negative_price += moneyDiscount;
	// 		}
	// 	}

	// 	return returnObjectInfo ? returnObject : negative_price;
	// }
	// ЗАМЕНИ ЦЯЛАТА getOrderTypeDiscount функция в Utils.js (от ред 968 до ред 1025):

	// static getOrderTypeDiscount = (choosenPlace, orderType, currentCartPrice, returnObjectInfo = false, promocodeData = [], products = null, settings = null, productIngredients = null) => {
	// 	let now = new Date();
	// 	let currentHour = now.getHours();
	// 	let currentMinutes = now.getMinutes();
	// 	let currentSeconds = now.getSeconds();

	// 	let currentPlaceOrderType = choosenPlace && choosenPlace.ordertypes && choosenPlace.ordertypes.find(t => t.type == orderType);
	// 	let currentPlaceOrderTypeDiscount = currentPlaceOrderType && currentPlaceOrderType.discounts ? currentPlaceOrderType.discounts : [];

	// 	let negative_price = 0;
	// 	let returnObject = {};

	// 	let dateWithHoursForCompare = Date.parse('01/01/2021 ' + currentHour + ':' + currentMinutes + ':' + currentSeconds);
	// 	currentPlaceOrderTypeDiscount = currentPlaceOrderTypeDiscount.filter(d => Date.parse('01/01/2021 ' + d.active_start_time) <= dateWithHoursForCompare && dateWithHoursForCompare <= Date.parse('01/01/2021 ' + d.active_end_time))

	// 	// КРИТИЧНА ПРОВЕРКА: Ако има промокод с ignore_other_discounts = 1, НЕ прилагаме ordertype отстъпки
	// 	let shouldApplyOrdertypeDiscount = true;
	// 	if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.ignore_other_discounts) {
	// 		shouldApplyOrdertypeDiscount = false;
	// 	}

	// 	// Прилагаме ordertype discount само ако е позволено
	// 	if (shouldApplyOrdertypeDiscount && (Object.values(promocodeData).length == 0 || (promocodeData && promocodeData.payload && promocodeData.payload.found == false))) {
	// 		currentPlaceOrderTypeDiscount
	// 			.sort((a, b) => (a.price_over - b.price_over) || (a.value - b.value))
	// 			.map((d, k) => {
	// 				if (currentCartPrice >= d.price_over && (typeof currentPlaceOrderTypeDiscount[k + 1] === "undefined" || (typeof currentPlaceOrderTypeDiscount[k + 1] !== "undefined" && currentCartPrice < currentPlaceOrderTypeDiscount[k + 1].price_over))) {
	// 					returnObject.value_type = d.value_type;
	// 					returnObject.value = d.value;

	// 					if (d.value_type == 'percent') {
	// 						negative_price += (parseFloat(d.value) * parseFloat(currentCartPrice) / 100);
	// 					} else if (d.value_type == 'money') {
	// 						negative_price += parseFloat(d.value);
	// 					}
	// 				}
	// 			})
	// 	}

	// 	// Прилагаме promocode discount
	// 	if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.discount_value && promocodeData.payload.discount_type) {
	// 		let discountType = promocodeData.payload.discount_type;
	// 		let discountValue = promocodeData.payload.discount_value;

	// 		let priceForPromocode = currentCartPrice;

	// 		// Проверка дали да игнорираме другите отстъпки
	// 		if (promocodeData.payload.ignore_other_discounts) {
	// 			// Пресмятаме цената БЕЗ НИКАКВИ отстъпки (product, ordertype, category)
	// 			if (products && settings && productIngredients) {
	// 				priceForPromocode = parseFloat(this.calculateTotalPriceForOrder(
	// 					Object.values(products).filter(p => this.canApplyPromocodeToProduct(p)),
	// 					settings,
	// 					productIngredients,
	// 					true,
	// 					orderType,
	// 					promocodeData // Подаваме promocodeData за да calculateProductPriceOrder знае да НЕ прилага отстъпки
	// 				));
	// 			}
	// 		} else {
	// 			// Използваме цената СЛЕД ordertype discount
	// 			priceForPromocode = currentCartPrice - negative_price;

	// 			if (products && settings && productIngredients) {
	// 				let productsWithPromocode = Object.values(products).filter(p => this.canApplyPromocodeToProduct(p));
	// 				let totalPriceWithPromocode = parseFloat(this.calculateTotalPriceForOrder(productsWithPromocode, settings, productIngredients, true, orderType, null));

	// 				// Пропорционално намаляваме ordertype отстъпката
	// 				if (shouldApplyOrdertypeDiscount && negative_price > 0 && currentCartPrice > 0) {
	// 					let proportionalOrdertypeDiscount = negative_price * (totalPriceWithPromocode / currentCartPrice);
	// 					priceForPromocode = totalPriceWithPromocode - proportionalOrdertypeDiscount;
	// 				} else {
	// 					priceForPromocode = totalPriceWithPromocode;
	// 				}
	// 			}
	// 		}

	// 		// Прилагаме отстъпката от промокода
	// 		if (discountType == 'percent') {
	// 			let calculatedDiscount = (parseFloat(discountValue) * parseFloat(priceForPromocode) / 100);
	// 			negative_price += calculatedDiscount;
	// 		} else if (discountType == 'money') {
	// 			// За money discount не можем да дадем повече от цената
	// 			let moneyDiscount = Math.min(parseFloat(discountValue), Math.max(0, priceForPromocode));
	// 			negative_price += moneyDiscount;
	// 		}
	// 	}

	// 	return returnObjectInfo ? returnObject : negative_price;
	// }

	// payment_methods на отстъпката е JSON масив (напр. ["cash"]); празен/NULL = важи за всички методи на плащане
	static isOrderTypeDiscountAllowedForPaymentMethod = (discount, paymentMethod) => {
		let methods = [];
		try {
			methods = discount.payment_methods ? JSON.parse(discount.payment_methods) : [];
		} catch (e) {
			methods = [];
		}
		if (!Array.isArray(methods) || methods.length == 0) {
			return true;
		}
		// online_test (тестово плащане) се смята като online - както го записва сървърът
		let method = (paymentMethod || '').split('.')[0];
		if (method == 'online_test') method = 'online';
		return methods.includes(method);
	}

	// paymentMethod: null = без филтър по метод на плащане (напр. бутоните за избор на тип поръчка)
	static getOrderTypeDiscount = (choosenPlace, orderType, currentCartPrice, returnObjectInfo = false, promocodeData = [], products = null, settings = null, productIngredients = null, paymentMethod = null) => {
		let now = new Date();
		let currentHour = now.getHours();
		let currentMinutes = now.getMinutes();
		let currentSeconds = now.getSeconds();

		let currentPlaceOrderType = choosenPlace && choosenPlace.ordertypes && choosenPlace.ordertypes.find(t => t.type == orderType);
		let currentPlaceOrderTypeDiscount = currentPlaceOrderType && currentPlaceOrderType.discounts ? currentPlaceOrderType.discounts : [];

		// Отстъпка само за избрани методи на плащане (напр. само в брой)
		if (paymentMethod !== null) {
			currentPlaceOrderTypeDiscount = currentPlaceOrderTypeDiscount.filter(d => this.isOrderTypeDiscountAllowedForPaymentMethod(d, paymentMethod));
		}

		let negative_price = 0;
		let returnObject = {};

		let dateWithHoursForCompare = Date.parse('01/01/2021 ' + currentHour + ':' + currentMinutes + ':' + currentSeconds);
		currentPlaceOrderTypeDiscount = currentPlaceOrderTypeDiscount.filter(d => Date.parse('01/01/2021 ' + d.active_start_time) <= dateWithHoursForCompare && dateWithHoursForCompare <= Date.parse('01/01/2021 ' + d.active_end_time))

		// КРИТИЧНА ПРОВЕРКА: Ако има промокод с ignore_other_discounts = 1, НЕ прилагаме ordertype отстъпки
		let shouldApplyOrdertypeDiscount = true;
		if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.ignore_other_discounts) {
			shouldApplyOrdertypeDiscount = false;
		}

		// Прилагаме ordertype discount само ако е позволено
		// if (shouldApplyOrdertypeDiscount && (Object.values(promocodeData).length == 0 || (promocodeData && promocodeData.payload && promocodeData.payload.found == false))) {
		if (shouldApplyOrdertypeDiscount) {
			currentPlaceOrderTypeDiscount
				.sort((a, b) => (a.price_over - b.price_over) || (a.value - b.value))
				.map((d, k) => {
					if (currentCartPrice >= d.price_over && (typeof currentPlaceOrderTypeDiscount[k + 1] === "undefined" || (typeof currentPlaceOrderTypeDiscount[k + 1] !== "undefined" && currentCartPrice < currentPlaceOrderTypeDiscount[k + 1].price_over))) {
						returnObject.value_type = d.value_type;
						returnObject.value = d.value;

						if (d.value_type == 'percent') {
							negative_price += (parseFloat(d.value) * parseFloat(currentCartPrice) / 100);
						} else if (d.value_type == 'money') {
							negative_price += parseFloat(d.value);
						}
					}
				})
		}

		// Прилагаме promocode discount
		if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.discount_value && promocodeData.payload.discount_type) {
			let discountType = promocodeData.payload.discount_type;
			let discountValue = promocodeData.payload.discount_value;

			let priceForPromocode = currentCartPrice;

			// Проверка дали да игнорираме другите отстъпки
			if (promocodeData.payload.ignore_other_discounts) {
				// Пресмятаме цената БЕЗ НИКАКВИ отстъпки (product, ordertype, category)
				if (products && settings && productIngredients) {
					priceForPromocode = parseFloat(this.calculateTotalPriceForOrder(
						Object.values(products).filter(p => this.canApplyPromocodeToProduct(p, promocodeData)),
						settings,
						productIngredients,
						true,
						orderType,
						promocodeData // Подаваме promocodeData за да calculateProductPriceOrder знае да НЕ прилага отстъпки
					));
				}
			} else {
				// Използваме цената СЛЕД ordertype discount
				priceForPromocode = currentCartPrice - negative_price;

				if (products && settings && productIngredients) {
					let productsWithPromocode = Object.values(products).filter(p => this.canApplyPromocodeToProduct(p, promocodeData));
					// let totalPriceWithPromocode = parseFloat(this.calculateTotalPriceForOrder(productsWithPromocode, settings, productIngredients, true, orderType, null));

					let emptyPromocode = { payload: { found: false, ignore_other_discounts: 0 } };
					let totalPriceWithPromocode = parseFloat(this.calculateTotalPriceForOrder(productsWithPromocode, settings, productIngredients, true, orderType, emptyPromocode));


					// console.log('🔍 DEBUG BEFORE IF:');
					// console.log('shouldApplyOrdertypeDiscount:', shouldApplyOrdertypeDiscount);
					// console.log('negative_price:', negative_price);
					// console.log('currentCartPrice:', currentCartPrice);
					// console.log('totalPriceWithPromocode:', totalPriceWithPromocode);

					// KEY CHANGE:
					// Пропорционално намаляваме ordertype отстъпката
					if (shouldApplyOrdertypeDiscount && negative_price > 0 && currentCartPrice > 0) {
						let proportionalOrdertypeDiscount = negative_price * (totalPriceWithPromocode / currentCartPrice);
						priceForPromocode = totalPriceWithPromocode - proportionalOrdertypeDiscount;
						// 🔍 ДЕБЪГ ЛОГ:
						// console.log('🔍 DEBUG PROMOCODE:');
						// console.log('currentCartPrice:', currentCartPrice);
						// console.log('totalPriceWithPromocode:', totalPriceWithPromocode);
						// console.log('negative_price (ordertype):', negative_price);
						// console.log('proportionalOrdertypeDiscount:', proportionalOrdertypeDiscount);
						// console.log('priceForPromocode (final):', priceForPromocode);

					} else {
						priceForPromocode = totalPriceWithPromocode;
					}
				}
			}

			// Прилагаме отстъпката от промокода
			if (discountType == 'percent') {
				let calculatedDiscount = (parseFloat(discountValue) * parseFloat(priceForPromocode) / 100);
				negative_price += calculatedDiscount;
				returnObject.promocodeAppliedDiscount = calculatedDiscount;
			} else if (discountType == 'money') {
				// За money discount не можем да дадем повече от цената
				let moneyDiscount = Math.min(parseFloat(discountValue), Math.max(0, priceForPromocode));
				negative_price += moneyDiscount;
				returnObject.promocodeAppliedDiscount = moneyDiscount;
			}
		}

		return returnObjectInfo ? returnObject : negative_price;
	}

	static getOrderTypePrice = (choosenPlace, orderType, currentCartPrice, returnObjectInfo) => {
		// Delivery only for now
		// Money only for now value_type
		// Price instead of value
		let currentPlaceOrderType = choosenPlace.ordertypes.find(t => t.type == orderType);
		let currentPlaceOrderTypePrices = currentPlaceOrderType && currentPlaceOrderType.prices ? currentPlaceOrderType.prices : [];
		let positive_price = 0;
		let returnObject = {};


		currentPlaceOrderTypePrices.sort((a, b) => (a.price_over - b.price_over)).map((d, k) => {
			if (currentCartPrice >= d.price_over && (typeof currentPlaceOrderTypePrices[k + 1] === "undefined" || (typeof currentPlaceOrderTypePrices[k + 1] !== "undefined" && currentCartPrice < currentPlaceOrderTypePrices[k + 1].price_over))) {
				positive_price += parseFloat(d.price);
				returnObject.value_type = 'money';
				returnObject.value = d.price;
			}
		});

		return returnObjectInfo ? returnObject : positive_price;

	}

	// Calculate final price for all products + delivery price - Order Modal 
	// static calculateFinalPriceForOrder = (orderType, products, settings, productIngredients, regions, selectedRegion, choosenPlace, calculateAdditionalPrice = true, promocodeData = [], registeredUserDiscount = {}, deliveryRadiusId = null, deliveryShapeId = null, count_cutlery = 0, calculateWithDelivery = true, accumulatedOrderAmountUsed = false) => {
	// 	const additional_price_each_cutlery = this.getSettingsValue(settings, 'additional_price_each_cutlery')
	// 	let additionalPriceForEachCutleryCalculated = 0;

	// 	var totalCartPrice = parseFloat(this.calculateTotalPriceForOrder(products, settings, productIngredients, calculateAdditionalPrice, orderType));
	// 	let finalCartPrice = totalCartPrice;
	// 	// debugger;
	// 	let positive_price = 0;
	// 	let negative_price = 0;

	// 	negative_price += this.calculateOrderDiscountMoneyForCategories(products, settings);

	// 	if (orderType == 'delivery') {
	// 		// Do not calculcate if region is not selected
	// 		// if (regions.length > 0 && !selectedRegion) {
	// 		// 	return null;
	// 		// }

	// 		// Deliery Discount - FIRST (before delivery prices, because discount is not valid for delivery prices)
	// 		// negative_price += this.getOrderTypeDiscount(choosenPlace, 'delivery', finalCartPrice, false, promocodeData)
	// 		negative_price += this.getOrderTypeDiscount(choosenPlace, 'delivery', finalCartPrice, false, promocodeData, products, settings, productIngredients)

	// 		if (this.getDeliveryShapes()) {
	// 			if (deliveryShapeId) {
	// 				let myShape = this.getDeliveryShapes().find(r => r.id == deliveryShapeId);

	// 				if (myShape.required_order_price_for_free_delivery && myShape.required_order_price_for_free_delivery > 0 && finalCartPrice >= myShape.required_order_price_for_free_delivery) {
	// 				} else {
	// 					positive_price += parseFloat(myShape.delivery_price)
	// 				}
	// 				// if(myShape.required_order_price_for_free_delivery <= 0 || finalCartPrice < myShape.required_order_price_for_free_delivery) {
	// 				// 	positive_price += myShape.delivery_price
	// 				// }
	// 			}

	// 		} else if (this.getDeliveryRadiuses()) {
	// 			if (deliveryRadiusId) {
	// 				let myRadius = this.getDeliveryRadiuses().find(r => r.id == deliveryRadiusId);
	// 				if (myRadius.required_order_price_for_free_delivery && myRadius.required_order_price_for_free_delivery > 0 && finalCartPrice >= myRadius.required_order_price_for_free_delivery) {
	// 				} else {
	// 					positive_price += parseFloat(myRadius.delivery_price)
	// 				}
	// 				// if(myRadius.required_order_price_for_free_delivery <= 0 || finalCartPrice < myRadius.required_order_price_for_free_delivery) {
	// 				// 	positive_price += myRadius.delivery_price
	// 				// }
	// 				// console.log("CALCULATION 2", myRadius, positive_price);
	// 			}

	// 		} else {
	// 			const orderTypeCurrentPrice = this.getOrderTypePrice(choosenPlace, 'delivery', finalCartPrice, true);
	// 			if (choosenPlace && choosenPlace.ordertypes && orderTypeCurrentPrice && orderTypeCurrentPrice.value) {
	// 				// Delivery price order type - (IF NOT REGIONS)
	// 				positive_price += orderTypeCurrentPrice.value
	// 			} else if (regions.length > 0 && selectedRegion) {
	// 				let selectedRegionPrice = regions.find(r => r.id == selectedRegion);
	// 				selectedRegionPrice = selectedRegionPrice && selectedRegionPrice.delivery_price ? selectedRegionPrice.delivery_price : 0;
	// 				positive_price += parseFloat(selectedRegionPrice);
	// 			}
	// 		}

	// 		if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
	// 			additionalPriceForEachCutleryCalculated += parseFloat(parseInt(count_cutlery) * parseFloat(additional_price_each_cutlery))
	// 		}

	// 		positive_price = parseFloat(positive_price) + parseFloat(this.calculateBoxesForProducts(products, settings, 'delivery'))

	// 	} else if (orderType == 'preorder') {
	// 		if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
	// 			additionalPriceForEachCutleryCalculated = parseFloat(parseInt(count_cutlery) * parseFloat(additional_price_each_cutlery));
	// 			additionalPriceForEachCutleryCalculated = parseFloat(additionalPriceForEachCutleryCalculated);
	// 			// finalCartPrice = finalCartPrice + additionalPriceForEachCutleryCalculated;

	// 		}
	// 		positive_price = parseFloat(positive_price) + parseFloat(this.calculateBoxesForProducts(products, settings, 'preorder'))

	// 		// Preorder Discount
	// 		// negative_price += this.getOrderTypeDiscount(choosenPlace, 'preorder', finalCartPrice, false, promocodeData)
	// 		// negative_price += this.getOrderTypeDiscount(choosenPlace, 'preorder', finalCartPrice, false, promocodeData)
	// 		negative_price += this.getOrderTypeDiscount(choosenPlace, 'preorder', finalCartPrice, false, promocodeData, products, settings, productIngredients);

	// 	}

	// 	negative_price = parseFloat(negative_price);
	// 	finalCartPrice = finalCartPrice - negative_price;

	// 	if (registeredUserDiscount && registeredUserDiscount.discount && registeredUserDiscount.ordersCount &&
	// 		parseInt(registeredUserDiscount.discount.on_order_number) == (parseInt(registeredUserDiscount.ordersCount) + 1)
	// 	) {
	// 		finalCartPrice -= registeredUserDiscount.discount.discount_type == 'money' ? parseFloat(registeredUserDiscount.discount.discount_amount) :
	// 			parseFloat(registeredUserDiscount.discount.discount_amount) * parseFloat(finalCartPrice) / 100
	// 	}

	// 	if (calculateWithDelivery) {
	// 		positive_price = parseFloat(positive_price);
	// 		finalCartPrice = finalCartPrice + positive_price;
	// 	}

	// 	if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
	// 		finalCartPrice = finalCartPrice + additionalPriceForEachCutleryCalculated;
	// 	}

	// 	// if(accumulatedOrderAmountUsed && Auth.getDecodedUser()) {
	// 	// 	let userAmount = Auth.getDecodedUser().accumulated_order_amount;

	// 	// 	if(finalCartPrice <= userAmount) {
	// 	// 		finalCartPrice -= finalCartPrice;
	// 	// 	} else {
	// 	// 		finalCartPrice -= userAmount;
	// 	// 	}
	// 	// }

	// 	finalCartPrice = this.round(finalCartPrice);
	// 	finalCartPrice = parseFloat(finalCartPrice).toFixed(2);

	// 	return finalCartPrice;

	// 	// return (totalCartPrice != finalCartPrice) ? finalCartPrice : null;
	// }


	// подава се promocodeData
	static calculateFinalPriceForOrder = (orderType, products, settings, productIngredients, regions, selectedRegion, choosenPlace, calculateAdditionalPrice = true, promocodeData = [], registeredUserDiscount = {}, deliveryRadiusId = null, deliveryShapeId = null, count_cutlery = 0, calculateWithDelivery = true, accumulatedOrderAmountUsed = false, paymentMethod = null) => {
		const additional_price_each_cutlery = this.getSettingsValue(settings, 'additional_price_each_cutlery')
		let additionalPriceForEachCutleryCalculated = 0;

		// ПРОВЕРКА: Ако има промокод с ignore_other_discounts = 1
		let shouldApplyOtherDiscounts = true;
		if (promocodeData && promocodeData.payload && promocodeData.payload.found && promocodeData.payload.ignore_other_discounts) {
			shouldApplyOtherDiscounts = false;
		}

		// Изчисляваме тотал price (с или без product discounts в зависимост от promocode)
		var totalCartPrice = parseFloat(this.calculateTotalPriceForOrder(products, settings, productIngredients, calculateAdditionalPrice, orderType, promocodeData));
		let finalCartPrice = totalCartPrice;

		let positive_price = 0;
		let negative_price = 0;

		// Category discount (само ако shouldApplyOtherDiscounts = true)
		if (shouldApplyOtherDiscounts) {
			negative_price += this.calculateOrderDiscountMoneyForCategories(products, settings, null);
		}

		if (orderType == 'delivery') {
			// Ordertype Discount (само ако shouldApplyOtherDiscounts = true)
			negative_price += this.getOrderTypeDiscount(choosenPlace, 'delivery', finalCartPrice, false, promocodeData, products, settings, productIngredients, paymentMethod)

			// Delivery price
			if (this.getDeliveryShapes()) {
				let myShape = deliveryShapeId ? this.getDeliveryShapes().find(r => r.id == deliveryShapeId) : null;
				if (myShape) {
					if (myShape.required_order_price_for_free_delivery && myShape.required_order_price_for_free_delivery > 0 && finalCartPrice >= myShape.required_order_price_for_free_delivery) {
					} else {
						positive_price += parseFloat(myShape.delivery_price)
					}
				}
			} else if (this.getDeliveryRadiuses()) {
				let myRadius = deliveryRadiusId ? this.getDeliveryRadiuses().find(r => r.id == deliveryRadiusId) : null;
				if (myRadius) {
					if (myRadius.required_order_price_for_free_delivery && myRadius.required_order_price_for_free_delivery > 0 && finalCartPrice >= myRadius.required_order_price_for_free_delivery) {
					} else {
						positive_price += parseFloat(myRadius.delivery_price)
					}
				}
			} else {
				const orderTypeCurrentPrice = this.getOrderTypePrice(choosenPlace, 'delivery', finalCartPrice, true);
				if (choosenPlace && choosenPlace.ordertypes && orderTypeCurrentPrice && orderTypeCurrentPrice.value) {
					positive_price += orderTypeCurrentPrice.value
				} else if (regions.length > 0 && selectedRegion) {
					let selectedRegionPrice = regions.find(r => r.id == selectedRegion);
					selectedRegionPrice = selectedRegionPrice && selectedRegionPrice.delivery_price ? selectedRegionPrice.delivery_price : 0;
					positive_price += parseFloat(selectedRegionPrice);
				}
			}

			if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
				additionalPriceForEachCutleryCalculated += parseFloat(parseInt(count_cutlery) * parseFloat(additional_price_each_cutlery))
			}

			positive_price = parseFloat(positive_price) + parseFloat(this.calculateBoxesForProducts(products, settings, 'delivery'))

		} else if (orderType == 'preorder') {
			if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
				additionalPriceForEachCutleryCalculated = parseFloat(parseInt(count_cutlery) * parseFloat(additional_price_each_cutlery));
				additionalPriceForEachCutleryCalculated = parseFloat(additionalPriceForEachCutleryCalculated);
			}
			positive_price = parseFloat(positive_price) + parseFloat(this.calculateBoxesForProducts(products, settings, 'preorder'))

			// Ordertype Discount (само ако shouldApplyOtherDiscounts = true)
			negative_price += this.getOrderTypeDiscount(choosenPlace, 'preorder', finalCartPrice, false, promocodeData, products, settings, productIngredients, paymentMethod);
		} else {
			// За всички останали orderTypes (room, spot, served-on-spot и т.н.)
			if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
				additionalPriceForEachCutleryCalculated = parseFloat(parseInt(count_cutlery) * parseFloat(additional_price_each_cutlery));
				additionalPriceForEachCutleryCalculated = parseFloat(additionalPriceForEachCutleryCalculated);
			}
			positive_price = parseFloat(positive_price) + parseFloat(this.calculateBoxesForProducts(products, settings, orderType))

			// Ordertype Discount с promocode поддръжка
			if (choosenPlace && choosenPlace.ordertypes) {
				negative_price += this.getOrderTypeDiscount(choosenPlace, orderType, finalCartPrice, false, promocodeData, products, settings, productIngredients, paymentMethod);
			}
		}

		negative_price = parseFloat(negative_price);
		finalCartPrice = finalCartPrice - negative_price;

		// Registered User Discount (само ако shouldApplyOtherDiscounts = true)
		if (shouldApplyOtherDiscounts && registeredUserDiscount && registeredUserDiscount.discount && registeredUserDiscount.ordersCount &&
			parseInt(registeredUserDiscount.discount.on_order_number) == (parseInt(registeredUserDiscount.ordersCount) + 1)
		) {
			finalCartPrice -= registeredUserDiscount.discount.discount_type == 'money' ? parseFloat(registeredUserDiscount.discount.discount_amount) :
				parseFloat(registeredUserDiscount.discount.discount_amount) * parseFloat(finalCartPrice) / 100
		}

		if (calculateWithDelivery) {
			positive_price = parseFloat(positive_price);
			finalCartPrice = finalCartPrice + positive_price;
		}

		if (additional_price_each_cutlery && additional_price_each_cutlery != '0') {
			finalCartPrice = finalCartPrice + additionalPriceForEachCutleryCalculated;
		}

		finalCartPrice = this.round(finalCartPrice);
		finalCartPrice = parseFloat(finalCartPrice).toFixed(2);

		return finalCartPrice;
	}

	static calculateTaxOnlinePayments(finalPrice, settings) {

		const additionalTaxOnlinePaymentsPercent = parseFloat(this.getSettingsValue(settings, 'additional_tax_online_payment_percent'));
		const additionalTaxOnlinePaymentsFixed = parseFloat(this.getSettingsValue(settings, 'additional_tax_online_payment_fixed'));
		let newFinalPrice = (finalPrice * additionalTaxOnlinePaymentsPercent / 100) + additionalTaxOnlinePaymentsFixed;

		newFinalPrice = parseFloat(newFinalPrice).toFixed(2);

		return newFinalPrice;

	}

	static calculateOnlinePaymentDiscount(finalPrice, settings) {
		const percent = parseFloat(this.getSettingsValue(settings, 'online_payment_discount_percent')) || 0;
		const fixed = parseFloat(this.getSettingsValue(settings, 'online_payment_discount_fixed')) || 0;
		let discount = (finalPrice * percent / 100) + fixed;
		discount = parseFloat(discount).toFixed(2);
		return discount;
	}

	static calculateUsedAccumulatedOrderAmount(isUsed, finalCartPrice) {
		let usedAmount = 0;

		if (isUsed && Auth.getDecodedUser()) {
			// let userAmount = Auth.getDecodedUser().accumulated_order_amount;

			let currState = store.getState();
			let userAmount = currState && currState.accumulatedOrderAmountSetting ? currState.accumulatedOrderAmountSetting.setting.accumulatedUserAmount : 0;

			userAmount = parseFloat(userAmount);
			finalCartPrice = parseFloat(finalCartPrice);

			if (finalCartPrice <= userAmount) {
				usedAmount = finalCartPrice;
			} else {
				usedAmount = userAmount;
			}
		}

		return usedAmount;
	}

	static round(num) {
		return Math.round(num * 100) / 100;
	}

	static simpleHandleScrollToOnPop(settings, action, location = null, scrollData = null, forseTop = false) {
		const pageContainerElement = document.getElementById('page-container');
		if (pageContainerElement) {
			pageContainerElement.scrollTo({ left: 0, top: 0 });
		}
	}


	static handleScrollToOnPop(settings, action, location = null, scrollData = null, forseTop = false) {
		const pageContainerElement = document.getElementById('page-container');
		if (pageContainerElement) {
			pageContainerElement.scrollTo({ left: 0, top: 0 });
		}


		// console.log("SCROL ", action, location, scrollData);
		if (this.getSettingsValue(settings, 'pdf_menu_enabled') == '1') {
			document.querySelector('[data-class="all-products-container"]').scrollIntoView();
		}

		if (forseTop) {
			if (this.getSettingsValue(settings, 'pdf_menu_enabled') == '1') {
				pageContainerElement.scrollTo({ left: 0, top: 0 });
			} else if (document.querySelector('[data-class="swipeable-container"]')) {
				document.querySelector('[data-class="swipeable-container"]').scrollTo({ left: 0, top: 0 });
			}
		} else {

			if (action === "SWIPE") {
				pageContainerElement.scrollTo({ left: 0, top: 0 });

				if (document.querySelector('[data-class="swipeable-container"]')) {
					setTimeout(document.querySelector('[data-class="swipeable-container"]').scrollTo({ left: 0, top: 0 }));
				}

			} else if (action === "POP" && location && scrollData) {
				if (scrollData && scrollData[location.pathname]) {
					setTimeout(() => {
						document.querySelector('[data-class="swipeable-container"]').scrollTo({
							left: 0,
							top: scrollData[location.pathname],
							behavior: "smooth"
						})

						store.dispatch(setScrollData({}))
					}

					);
				} else {
					//  if (document.querySelector('[data-class="swipeable-container"]')) {
					//      document.querySelector('[data-class="swipeable-container"]').scrollTo({ left: 0, top: 0 });
					//  }
				}
			} else if (action === "PUSH") {
				pageContainerElement.scrollTo({ left: 0, top: 0 });
			} else {
				// if (document.querySelector('[data-class="swipeable-container"]')) {
				//      setTimeout(document.querySelector('[data-class="swipeable-container"]').scrollTo({ left: 0, top: 0 }));
				// }
			}
		}

	}

	static hasFunctionalityModule = (functionalityModule) => {
		let currState = store.getState();

		if (currState && currState.places && currState.places.places) {
			let currPlace = currState.places.places.find(p => p.id == Auth.getOpenedPlace());
			if (currPlace && currPlace.functionality_modules) {
				let functionalityModulesForPlace = currPlace.functionality_modules;

				if (functionalityModulesForPlace.find(f => f == functionalityModule)) {
					return true;
				}
			}
		}

		return false;
	}

	static getCurrPlaceData = () => {
		let currState = store.getState();

		if (currState && currState.places && currState.places.places) {
			let p = currState.places.places.find(p => p.id == Auth.getOpenedPlace());
			if (p) return p;
		}

		return null;
	}

	static getDeliveryRadiuses = () => {
		let currPlace = this.getCurrPlaceData();

		if (currPlace && currPlace.ordertypes) {
			let delivery = currPlace.ordertypes.find(p => p.type == 'delivery');

			if (delivery && delivery.radiuses && delivery.radiuses.length > 0) {
				return delivery.radiuses
			}
		}

		return null;
	}

	/*
		distance - in meters
	*/
	static getDeliveryRadiusByDistance = (distance) => {
		if (distance === null || distance === undefined || isNaN(distance)) return null;

		let currPlace = this.getCurrPlaceData();

		let myRadius = null;
		if (currPlace && currPlace.ordertypes) {
			let delivery = currPlace.ordertypes.find(p => p.type == 'delivery');

			if (delivery && delivery.radiuses && delivery.radiuses.length > 0) {
				for (let r = 0; r < delivery.radiuses.length; r++) {
					let currRadius = delivery.radiuses[r];
					if (currRadius.radius_start <= distance && distance < currRadius.radius_end) {
						myRadius = currRadius;
						break;
					}
				}
			}
		}

		return myRadius;
	}

	/*
		Distance in meters from the current place to lat/lng, or null when the place has no
		coordinates (lat/lng are strings in the DB and are sometimes typed with a decimal comma).
	*/
	static getDistanceFromCurrPlace = (lat, lng) => {
		const place = this.getCurrPlaceData();
		if (!place) return null;

		const toNum = (v) => (v === null || v === undefined || String(v).trim() === '') ? NaN : parseFloat(String(v).trim().replace(',', '.'));
		const placeLat = toNum(place.lat), placeLng = toNum(place.lng);
		const pointLat = toNum(lat), pointLng = toNum(lng);
		if ([placeLat, placeLng, pointLat, pointLng].some(v => isNaN(v))) return null;

		return getDistance(
			{ latitude: placeLat, longitude: placeLng },
			{ latitude: pointLat, longitude: pointLng }
		);
	}

	static getDeliveryShapes = () => {
		let currPlace = this.getCurrPlaceData();

		if (currPlace && currPlace.ordertypes) {
			let delivery = currPlace.ordertypes.find(p => p.type == 'delivery');
			// console.log('delivery', delivery);
			if (delivery && delivery.delivery_shapes && delivery.delivery_shapes.length > 0) {
				let shapes = delivery.delivery_shapes

				// priority е текстова колона в базата -> сървърът сортира "10" преди "2". При застъпващи се
				// зони печели първата намерена, затова подреждаме числово (стабилно, на място).
				shapes.sort((a, b) => (parseInt(a.priority) || 0) - (parseInt(b.priority) || 0));

				for (let i = 0; i < shapes.length; i++) {

					// Added option to show/hide delivery shapes in specific time range
					if (shapes[i].active_time_from && shapes[i].active_time_to) {

						const parseTime = (timeString) => {
							const [hours, minutes] = timeString.split(":").map(Number);
							return { hours, minutes };
						};

						const timeToMinutes = ({ hours, minutes }) => hours * 60 + minutes;

						const now = new Date();
						const currentTimeString = now.toTimeString().slice(0, 5);
						const currentTime = parseTime(currentTimeString);

						const startTime = parseTime(shapes[i].active_time_from);
						const endTime = parseTime(shapes[i].active_time_to);

						const currentTimeMinutes = timeToMinutes(currentTime);
						const startTimeMinutes = timeToMinutes(startTime);
						const endTimeMinutes = timeToMinutes(endTime);

						if (currentTimeMinutes >= startTimeMinutes && currentTimeMinutes <= endTimeMinutes) {
							// its allowed - continue ..
						} else {
							continue; //skip this region
						}
					}

					if (shapes[i].coordinates && typeof shapes[i].coordinates == "string") {
						// console.log( "CHECK ", shapes[i].coordinates)
						shapes[i].coordinates = JSON.parse(shapes[i].coordinates)
					}
				}

				return shapes;
			}
		}

		return null;
	}

	static setJsCookie = (cname, cvalue, exdays) => {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + (process && process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'production' ? ';secure=true;' : '');
	}

	static saveAddress = (address) => {
		let addresses = window.localStorage.getItem(TABL_USER_ADDRESSES_KEY);

		if (!addresses) addresses = {};
		else addresses = JSON.parse(addresses);

		addresses[address.placeId] = address;

		window.localStorage.setItem(TABL_USER_ADDRESSES_KEY, JSON.stringify(addresses))
	}

	static getUserAddresses = () => {
		return JSON.parse(window.localStorage.getItem(TABL_USER_ADDRESSES_KEY));
	}

	static getUserAddressById = (id) => {
		let addresses = JSON.parse(window.localStorage.getItem(TABL_USER_ADDRESSES_KEY));
		return addresses[id] ?? null;
	}

	static removeUserAddress = (addressId) => {
		let addresses = window.localStorage.getItem(TABL_USER_ADDRESSES_KEY);

		if (!addresses) addresses = {};
		else addresses = JSON.parse(addresses);

		delete addresses[addressId];

		window.localStorage.setItem(TABL_USER_ADDRESSES_KEY, JSON.stringify(addresses))
	}

	static calculateDistance(lattitude1, longittude1, lattitude2, longittude2) {

		const toRadian = n => (n * Math.PI) / 180

		let lat2 = lattitude2
		let lon2 = longittude2
		let lat1 = lattitude1
		let lon1 = longittude1

		// console.log(lat1, lon1 + "===" + lat2, lon2)
		let R = 6371  // km
		let x1 = lat2 - lat1
		let dLat = toRadian(x1)
		let x2 = lon2 - lon1
		let dLon = toRadian(x2)
		let a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
		let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
		let d = R * c
		// console.log("distance==?", d)
		return d;

	}


	static getUrlParams(queryString) {
		// Remove the leading '?' if present
		if (queryString.startsWith('?')) {
			queryString = queryString.substring(1);
		}

		// Use URLSearchParams to parse the query string
		const searchParams = new URLSearchParams(queryString);

		// Create an object to hold the parameters
		const params = {};

		// Iterate over the search parameters and add them to the object
		for (const [key, value] of searchParams.entries()) {
			params[key] = value;
		}

		return params;
	}

	static getCurrencySuffix() {
		const earlyConversionStartDate = new Date('2025-12-29T00:00:00');
		const now = new Date();
		const EARLY_CONVERTED_PLACE_IDS = now >= earlyConversionStartDate ? [134] : [];
		const euroDate = new Date('2025-12-31T22:00:00');
		const placeId = Auth.getOpenedPlace();
		const isEarlyConverted = placeId && EARLY_CONVERTED_PLACE_IDS.includes(parseInt(placeId));

		if (now >= euroDate || isEarlyConverted) {
			return '€';
		} else {
			return 'лв.';
		}
	}

	static showPricesInEuroCurrency(value) {
		// След 1 януари 2026 цените в базата са в EUR, показваме в лева
		// До тогава цените са в лева, показваме в евро
		//
		// EARLY_CONVERTED_PLACE_IDS - плейсове които са превалутирани преди 1 януари
		// За тях показваме лева (като че ли вече е след 1 януари)
		// Активира се от 29 декември 2025
		// Дата за ранно превалутиране (place 134)
		const earlyConversionStartDate = new Date('2025-12-29T00:00:00');
		const now = new Date();
		const EARLY_CONVERTED_PLACE_IDS = now >= earlyConversionStartDate ? [
			// Тук се добавят place_id-та на плейсове превалутирани преди 1 януари
			134
		] : [];

		// Дата за основно превалутиране (всички останали)
		const euroDate = new Date('2025-12-31T22:00:00');

		// Взимаме placeId от cookie/localStorage
		const placeId = Auth.getOpenedPlace();

		// Проверка дали плейсът е в списъка с ранно превалутирани
		const isEarlyConverted = placeId && EARLY_CONVERTED_PLACE_IDS.includes(parseInt(placeId));

		if (now >= euroDate || isEarlyConverted) {
			// Цената е в EUR, показваме в лева
			return (parseFloat(value) * 1.95583).toFixed(2) + ' лв.';
		} else {
			// Цената е в лева, показваме в евро
			return (parseFloat(value) / 1.95583).toFixed(2) + ' €';
		}
	}

	static getDeviceAndBrowserDetails() {
		var nVer = navigator.fullVersion;
		var nAgt = navigator.userAgent;
		var browserName = navigator.appName;
		var fullVersion = '' + parseFloat(navigator.appVersion);
		var majorVersion = parseInt(navigator.appVersion, 10);
		var nameOffset, verOffset, ix;

		// In Opera, the true version is after "OPR" or after "Version"
		if ((verOffset = nAgt.indexOf("OPR")) != -1) {
			browserName = "Opera";
			fullVersion = nAgt.substring(verOffset + 4);
			if ((verOffset = nAgt.indexOf("Version")) != -1)
				fullVersion = nAgt.substring(verOffset + 8);
		}
		// In MS Edge, the true version is after "Edg" in userAgent
		else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
			browserName = "Microsoft Edge";
			fullVersion = nAgt.substring(verOffset + 4);
		}
		// In MSIE, the true version is after "MSIE" in userAgent
		else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
			browserName = "Microsoft Internet Explorer";
			fullVersion = nAgt.substring(verOffset + 5);
		}
		// In Chrome, the true version is after "Chrome" 
		else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
			browserName = "Chrome";
			fullVersion = nAgt.substring(verOffset + 7);
		}
		// In Safari, the true version is after "Safari" or after "Version" 
		else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
			browserName = "Safari";
			fullVersion = nAgt.substring(verOffset + 7);
			if ((verOffset = nAgt.indexOf("Version")) != -1)
				fullVersion = nAgt.substring(verOffset + 8);
		}
		// In Firefox, the true version is after "Firefox" 
		else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
			browserName = "Firefox";
			fullVersion = nAgt.substring(verOffset + 8);
		}
		// In most other browsers, "name/version" is at the end of userAgent 
		else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
			(verOffset = nAgt.lastIndexOf('/'))) {
			browserName = nAgt.substring(nameOffset, verOffset);
			fullVersion = nAgt.substring(verOffset + 1);
			if (browserName.toLowerCase() == browserName.toUpperCase()) {
				browserName = navigator.appName;
			}
		}
		// trim the fullVersion string at semicolon/space if present
		if ((ix = fullVersion.indexOf(";")) != -1)
			fullVersion = fullVersion.substring(0, ix);
		if ((ix = fullVersion.indexOf(" ")) != -1)
			fullVersion = fullVersion.substring(0, ix);

		majorVersion = parseInt('' + fullVersion, 10);
		if (isNaN(majorVersion)) {
			fullVersion = '' + parseFloat(navigator.appVersion);
			majorVersion = parseInt(navigator.appVersion, 10);
		}

		return 'Browser name = ' + browserName + " "
			+ 'Full version = ' + fullVersion + " "
			+ 'Major version = ' + majorVersion + " "
			+ 'navigator.appName = ' + navigator.appName + " "
			+ 'navigator.userAgent = ' + navigator.userAgent + " "

	}

}

export default Utils;